import React, { useState, useRef, useEffect } from 'react';  // ✅ 正确
import { Product } from '../App';
import { Lang, langNames } from '../i18n';
type User = {
  uid: string,
  username: string
};
type Order = {
  id: number,
  pi_payment_id: string,
  product_id: string,
  user_uid: string,
  paid: number,
  txid: string | null,
  cancelled: number,
  refunded: number,
  created_at: string,
  merchant_id: number | null,
  shipping_status: string | null,
  tracking_number: string | null,
  shipped_at: string | null,
  refund_status: string | null,
  refund_reason: string | null,
  quantity: number,
  completed_at: string | null,
  product_name: string | null,
  product_image: string | null,
  piPrice: number | null,
};

const isDebug = false; // 全局调试开关：true 开启，false 关闭

// 图片压缩函数
const compressImage = (file: File, maxWidth: number, quality: number): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // 按比例缩放
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });
              resolve(compressedFile);
            } else {
              reject(new Error('压缩失败'));
            }
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => reject(new Error('图片加载失败'));
    };
    reader.onerror = () => reject(new Error('文件读取失败'));
  });
};

export default function Mine({ user, onSignIn, onSignOut, axiosClient, products, t, lang, changeLang }: { user: User | null, onSignIn: (user: User) => void, onSignOut: () => void, axiosClient: any, products: Product[], t: (key: string) => string, lang: Lang, changeLang: (lang: Lang) => void }) {
  const BRAND_COLORS = ['#611f69', '#0070ba', '#e85d04', '#2a9d8f', '#264653', '#e76f51', '#3a86ff', '#8338ec'];
  const [subPage, setSubPage] = useState<string>('main');
  const [orders, setOrders] = useState<Order[]>([]);
  const [favorites, setFavorites] = useState<any[]>([]);
  const [addresses, setAddresses] = useState<any[]>([]);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [couponCode, setCouponCode] = useState('');
  const [addrForm, setAddrForm] = useState({ name: '', phone: '', address: '', is_default: false });
  const [editingAddrId, setEditingAddrId] = useState<string | null>(null);
  const [merchantStatus, setMerchantStatus] = useState<string | null>(null);
  const [mName, setMName] = useState('');
  const [mContact, setMContact] = useState('');
  const [mPhone, setMPhone] = useState('');
  const [mDesc, setMDesc] = useState('');
  const [mAgree, setMAgree] = useState(false);
  const [merchantType, setMerchantType] = useState<'personal' | 'enterprise'>('personal');
  const [country, setCountry] = useState('CN');
  const [email, setEmail] = useState('');
  const [idCardFront, setIdCardFront] = useState('');
  const [idCardBack, setIdCardBack] = useState('');
  const [businessLicense, setBusinessLicense] = useState('');
  const [legalIdCard, setLegalIdCard] = useState('');
  const [rejectReason, setRejectReason] = useState('');
  const [myProducts, setMyProducts] = useState<any[]>([]);
  const [withdrawWallet, setWithdrawWallet] = useState('');
  const [showProductForm, setShowProductForm] = useState(false);
  const [editProductId, setEditProductId] = useState<string | null>(null);
  const [pForm, setPForm] = useState({ 
    name: '', image: '', piPrice: '', originalPrice: '', category: '', description: '', stock: '', coupon: '',
    skus: [] as any[]
  });

    // 钱包相关
  const [walletStatus, setWalletStatus] = useState<any>(null);
  const [walletBalances, setWalletBalances] = useState<any[]>([]);
  const [walletTxs, setWalletTxs] = useState<any[]>([]);
  const [bindEmail, setBindEmail] = useState('');
  const [bindPin, setBindPin] = useState('');
  const [bindStep, setBindStep] = useState(1); // 1=输入邮箱 2=验证完成
  const [walletLoading, setWalletLoading] = useState(false);
  const [payMethod, setPayMethod] = useState<'pcm' | 'pi'>('pi'); // 默认 Pi 直付
  const [walletInfo, setWalletInfo] = useState<any>(null);
  const [walletSubPage, setWalletSubPage] = useState<string>('main');
  const [transferTo, setTransferTo] = useState('');
  const [transferAmount, setTransferAmount] = useState('');
  const [transferRemark, setTransferRemark] = useState('');
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [withdrawAddress, setWithdrawAddress] = useState('');
  const [transferPin, setTransferPin] = useState<string>('');
  const [verifyCode, setVerifyCode] = useState('');
  const [sendingCode, setSendingCode] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [txFilter, setTxFilter] = useState<string>('all');
  const handleSendCode = async () => {
    if (!bindEmail.includes('@')) { alert('请先输入有效邮箱'); return; }
    setSendingCode(true);
    try {
      const res = await axiosClient.post('/wallet/send-code', { email: bindEmail });
      if (res.data?.success) {
        alert(`验证码已发送！${res.data.debugCode ? '测试码：' + res.data.debugCode : ''}`);
        setCountdown(60);
        const timer = setInterval(() => {
          setCountdown(prev => {
            if (prev <= 1) { clearInterval(timer); return 0; }
            return prev - 1;
          });
        }, 1000);
      }
    } catch (e: any) {
      alert('发送失败：' + (e.response?.data?.error || '未知错误'));
    } finally {
      setSendingCode(false);
    }
  };

  const handleResetPinCode = async () => {
    if (!resetEmail || !resetCode || !resetNewPin) { alert('请填写完整信息'); return; }
    if (resetNewPin.length < 6) { alert('密码至少6位'); return; }
    try {
      const res = await axiosClient.post('/wallet/reset-pin', {
        email: resetEmail,
        code: resetCode,
        newPin: resetNewPin
      });
      if (res.data?.success) {
        alert('✅ 支付密码重置成功！');
        setResetEmail(''); setResetCode(''); setResetNewPin('');
        setWalletSubPage('main');
      }
    } catch (e: any) {
      alert(e.response?.data?.error || '重置失败');
    }
  };

  const [resetEmail, setResetEmail] = useState<string>('');
  const [resetCode, setResetCode] = useState<string>('');
  const [resetNewPin, setResetNewPin] = useState<string>('');
  const [sendingResetCode, setSendingResetCode] = useState(false);
  const [resetCountdown, setResetCountdown] = useState(0);

   // 查询钱包状态

  const fetchWalletStatus = async () => {
    try {
      const res = await axiosClient.get('/wallet/status');
      console.log('Wallet status:', res.data); // 调试用
      setWalletStatus(res.data);
    } catch (e: any) {
      console.error('Wallet status error:', e.response?.status, e.response?.data);
      // 关键：只有明确返回 bound=false 才显示未合并
      if (e.response?.data?.bound === false) {
        setWalletStatus({ bound: false });
      } else {
        // 401 或其他错误，保持 null，显示加载中
        setWalletStatus(null);
      }
    }
  };

  const [rechargeAmount, setRechargeAmount] = useState<number>(0);
  const [customAmount, setCustomAmount] = useState<string>('');
  const [piRecharging, setPiRecharging] = useState(false);

  const [merchantOrders, setMerchantOrders] = useState<any[]>([]);
  const [orderFilter, setOrderFilter] = useState('pending');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [shipOrderId, setShipOrderId] = useState<string | null>(null);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [refundReason, setRefundReason] = useState('');
  const [showTemplateText, setShowTemplateText] = useState(false);
  const templateContent = `name,price,piPrice,originalPrice,stock,category,description,image
iPhone 15,100,100,6999,50,手机,最新款苹果手机,https://example.com/1.jpg
纯棉T恤,5,5,99,200,男装,舒适透气纯棉,https://example.com/2.jpg
无线耳机,15,15,299,100,影音数码,降噪蓝牙耳机,https://example.com/3.jpg`;

  const [coupons, setCoupons] = useState<any[]>([]);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponForm, setCouponForm] = useState({
    code: '',
    discount: '',
    type: 'fixed',
    min_order: '0',
    max_uses: '',
    valid_to: ''
  });
  
  const [financeData, setFinanceData] = useState<any>(null);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [withdrawals, setWithdrawals] = useState<any[]>([]);
  const [piWalletAddress, setPiWalletAddress] = useState('');
  const [financeTab, setFinanceTab] = useState<'overview' | 'transactions' | 'withdrawals'>('overview');

  const [merchantStats, setMerchantStats] = useState<any>(null);
  const [productRanking, setProductRanking] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);

  const [storeForm, setStoreForm] = useState({ logo: '', announcement: '', business_hours: { open: true } });

  const [merchants, setMerchants] = useState<any[]>([]);
  const [selectedMerchantId, setSelectedMerchantId] = useState<string | null>(null);
  
  // 计算当前选中的店铺
  const currentMerchant = merchants.find((m: any) => String(m.id) === selectedMerchantId) || merchants[0] || null;
  const approvedMerchants = merchants.filter((m: any) => m.status === 'approved');
  const canCreateStore = approvedMerchants.length < (currentMerchant?.merchant_type === 'enterprise' ? 5 : 2);

  const [uploadingImage, setUploadingImage] = useState(false);
  const [userCoupons, setUserCoupons] = useState<any[]>([]);
  const [couponTab, setCouponTab] = useState<'all'|'unused'|'used'|'expired'>('all');
  const [availableCoupons, setAvailableCoupons] = useState<any[]>([]);
  const [parseUrl, setParseUrl] = useState('');
  const [parsing, setParsing] = useState(false);

  const [showImportModal, setShowImportModal] = useState(false);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (showImportModal) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [showImportModal]);

  const [importData, setImportData] = useState<any[]>([]);
  const [importLoading, setImportLoading] = useState(false);

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    setUploadingImage(true);
    try {
      // 压缩图片
      const compressedFile = await compressImage(file, 800, 0.8);
      
      const formData = new FormData();
      formData.append('file', compressedFile);
      
      const res = await axiosClient.post('/upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      setPForm({...pForm, image: res.data.url});
      alert('图片上传成功');
    } catch (err: any) {
      alert('上传失败: ' + (err.response?.data?.error || err.message));
    } finally {
      setUploadingImage(false);
    }
  };

    // 在组件 state 声明之后添加 useEffect（提前初始化）
 useEffect(() => {
  if (typeof window !== 'undefined' && window.Pi && !(window.Pi as any)._initialized) {
    try {
      const _w: any = window;
      const isSandbox = _w.__ENV && _w.__ENV.sandbox === "true";
      window.Pi.init({ version: "2.0", sandbox: !!isSandbox });
      console.log('Pi.init called on mount, sandbox:', !!isSandbox);
    } catch (e) {
      console.error('Pi.init error on mount:', e);
    }
  }
}, []);

  const onIncompletePaymentFound = (payment: any) => {
    console.log("onIncompletePaymentFound", payment);
    return new Promise<void>((resolve) => {
      axiosClient.post('/payments/incomplete', { payment })
        .catch((err: any) => console.error('incomplete payment error:', err))
        .finally(() => resolve());
    });
  };

  const signIn = async () => {
    // const isDebug = new URLSearchParams(window.location.search).get('debug') === '1';
    const debugStep = (step: number) => {
      if (isDebug) alert(`Step ${step}`);
    };

    try {
      debugStep(1);
      
      if (!window.Pi) {
        alert('错误：Pi SDK 未加载');
        return;
      }
      debugStep(2);
      
      // 如果还没初始化，先 init 并等待完成
      if (!window.Pi._initialized) {
        try {
          const _w: any = window;
          const isSandbox = _w.__ENV && _w.__ENV.sandbox === "true";
          window.Pi.init({ version: "2.0", sandbox: !!isSandbox });
        } catch (initErr: any) {
          console.error('Pi.init error:', initErr);
        }
        // 关键：给 SDK 内部初始化留出时间
        await new Promise(r => setTimeout(r, 500));
      }
      
      if (!window.Pi.authenticate) {
        alert('错误：Pi.authenticate 不存在');
        return;
      }
      debugStep(3);
      
      const scopes = ['username', 'payments'];
      debugStep(4);
      
      try {
        const authResult = await window.Pi.authenticate(scopes, onIncompletePaymentFound);
        debugStep(5);
        console.log('Login authResult:', authResult);
        
        if (!authResult || !authResult.user) {
          alert('错误：没有用户数据');
          return;
        }
        
        debugStep(6);
        await axiosClient.post('/user/signin', { authResult });
        onSignIn(authResult.user);
        debugStep(7);
      } catch (authErr: any) {
        // 过滤用户主动取消的情况，不弹"登录失败"
        const msg = authErr.message || '';
        if (msg.includes('cancel') || msg.includes('denied') || msg.includes('closed') || msg.includes('abort')) {
          console.log('User cancelled login');
          return;
        }
        alert('登录失败');
        console.error('authenticate error:', authErr);
      }
    } catch (err: any) {
      alert('登录异常');
      console.error('signIn error:', err);
    }
  }

  const uploadQualification = async (e: React.ChangeEvent<HTMLInputElement>, setter: (url: string) => void) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axiosClient.post('/upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setter(res.data.url);
    } catch (err: any) {
      alert('上传失败: ' + (err.response?.data?.error || err.message));
    }
  };
  
  const fetchOrders = async () => {
    try {
      const res = await axiosClient.get('/orders');
      const data = res.data;
      setOrders(Array.isArray(data) ? data : (data.orders || []));
    } catch (e) {
      console.log("fetchOrders error", e);
    }
  };

  const fetchFavorites = async () => {
    try {
      const res = await axiosClient.get('/favorites');
      setFavorites(res.data.favorites || []);
    } catch (e) {}
  };

  const fetchCoupons = async () => {
    try {
      const res = await axiosClient.get('/coupons');
      setCoupons(res.data.coupons || []);
    } catch (e) {}
  };

  const fetchAddresses = async () => {
    try {
      const res = await axiosClient.get('/addresses');
      setAddresses(res.data.addresses || []);
    } catch (e) {}
  };

  const fetchNotifications = async () => {
    try {
      const res = await axiosClient.get('/notifications');
      setNotifications(res.data.notifications || []);
    } catch (e) {}
  };

  const fetchUnreadCount = async () => {
    try {
      const res = await axiosClient.get('/notifications/unread-count');
      setUnreadCount(res.data.unreadCount || 0);
    } catch (e) {}
  };
  const fetchMerchantOrders = async (filter?: string) => {
    try {
      const f = filter || orderFilter;
      const requestUrl = `/merchants/orders?status=${f}&merchant_id=${selectedMerchantId}`;
      
      if (isDebug) {
        alert('准备请求: ' + requestUrl);
        alert('当前页面: ' + window.location.href);
      }
      
      const res = await axiosClient.get(requestUrl);
      
      if (isDebug) {
        alert('返回数据: ' + JSON.stringify(res.data));
      }
      
      setMerchantOrders(res.data.orders || []);
    } catch (e: any) {
      if (isDebug) {
        alert('请求报错详情: ' + JSON.stringify({
          message: e.message,
          code: e.code,
          status: e.response?.status,
          statusText: e.response?.statusText,
          data: e.response?.data,
          hasResponse: !!e.response,
          hasRequest: !!e.request,
        }));
      }
      console.log('fetchMerchantOrders error', e);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axiosClient.get('/products/categories');
      const data = Array.isArray(res.data) ? res.data : (res.data.categories || []);
      setCategoryList(data);
    } catch (e) {}
  };

  const fetchFinance = async () => {
    try {
      const res = await axiosClient.get(`/merchants/finance?merchant_id=${selectedMerchantId}`);
      setFinanceData(res.data.finance);
    } catch (e) {}
  };

  const fetchTransactions = async () => {
    try {
      const res = await axiosClient.get(`/merchants/transactions?merchant_id=${selectedMerchantId}`);
      setTransactions(res.data.transactions || []);
    } catch (e) {}
  };

  const fetchWithdrawals = async () => {
    try {
      const res = await axiosClient.get(`/merchants/withdrawals?merchant_id=${selectedMerchantId}`);
      setWithdrawals(res.data.withdrawals || []);
    } catch (e) {}
  };

  const fetchMerchantStats = async () => {
    try {
      const res = await axiosClient.get(`/merchants/stats?merchant_id=${selectedMerchantId}`);
      setMerchantStats(res.data.stats);
    } catch (e) {}
  };

  const fetchProductRanking = async () => {
    try {
      const res = await axiosClient.get(`/merchants/stats/products?merchant_id=${selectedMerchantId}`);
      setProductRanking(res.data.products || []);
    } catch (e) {}
  };

  const fetchMerchantCoupons = async () => {
    try {
      const res = await axiosClient.get('/merchants/coupons');
      setCoupons(res.data.coupons || []);
    } catch (e) {}
  };

  const createMerchantCoupon = async () => {
    // 先验证必填项
    if (!couponForm.code.trim()) { alert('Code is required'); return; }
    if (!couponForm.discount || isNaN(parseFloat(couponForm.discount))) { alert('Valid discount is required'); return; }
    
    const body = {
      code: couponForm.code.trim(),
      discount: parseFloat(couponForm.discount),
      type: couponForm.type,
      min_order: parseFloat(couponForm.min_order) || 0,
      max_uses: couponForm.max_uses ? parseInt(couponForm.max_uses) : null,
      valid_to: couponForm.valid_to || null
    };
    
    //alert('Sending: ' + JSON.stringify(body));  // ← 看发送的数据
    
    try {
      const res = await axiosClient.post('/merchants/coupons', body);
      alert('Success: ' + JSON.stringify(res.data));  // ← 看成功响应
      setShowCouponModal(false);
      setCouponForm({ code: '', discount: '', type: 'fixed', min_order: '0', max_uses: '', valid_to: '' });
      fetchMerchantCoupons();
    } catch (e: any) {
      // 静默失败，或只在控制台输出
      alert('Error detail: ' + (e.response?.data?.error || e.message || 'Unknown error'));  // ← 看具体错误
    }
  };

  const deleteMerchantCoupon = async (id: number) => {
  if (!window.confirm(t('text.confirmDelete') || 'Delete this coupon?')) return;
  try {
    await axiosClient.delete(`/merchants/coupons/${id}`);
    alert('删除成功'); // ← Pi Browser 能看到
    fetchMerchantCoupons();
  } catch (e: any) {
    alert('删除失败: ' + (e.response?.data?.error || e.message || '未知错误'));
    console.error('Delete coupon failed:', e);
  }
};

  const handleParseLink = async () => {
    if (!parseUrl.trim()) return;
    setParsing(true);
    try {
      const res = await axiosClient.post('/products/parse-link', { url: parseUrl.trim() });
      if (res.data?.success && res.data.data) {
        const d = res.data.data;
        
        // 调试：显示完整返回数据
        alert(
          `✅ 解析成功！\n\n` +
          `名称：${d.name || '无'}\n` +
          `价格：${d.price || '无'}\n` +
          `图片URL：${d.image || '空'}\n` +  // ← 关键：看图片URL是什么
          `描述：${d.description ? d.description.substring(0, 30) + '...' : '无'}`
        );
        
        setPForm((prev: any) => ({
          ...prev,
          name: d.name || prev.name,
          piPrice: d.price ? String(d.price) : prev.piPrice,
          originalPrice: d.originalPrice ? String(d.originalPrice) : (d.price ? String(d.price) : prev.originalPrice),
          image: d.image || prev.image,
          description: d.description || prev.description,
        }));
        
        setParseUrl('');
      }
    } catch (e: any) {
      alert('❌ 解析失败：' + (e.response?.data?.error || '该链接暂不支持或网站拒绝访问'));
    } finally {
      setParsing(false);
    }
  };

  // 查询余额
  const fetchWalletBalance = async () => {
    try {
      const res = await axiosClient.get('/wallet/balance');
      const balances = res.data?.balances || [];
      setWalletBalances(balances);
      // 去掉更新 walletStatus 的代码（避免闭包问题，walletStatus 由 fetchWalletStatus 管理）
    } catch (e) {
      console.log('Balance fetch error:', e);
      // 关键：API 失败时不要清空已有余额！
      // setWalletBalances([]);  ← 删除这行！
    }
  };

  // 查询交易记录
  const fetchWalletTxs = async () => {
    try {
      const res = await axiosClient.get('/wallet/transactions?limit=20');
      setWalletTxs(res.data.transactions || []);
    } catch (e) {}
  };

  // 绑定邮箱/合并账户
  const handleBindWallet = async () => {
    if (!bindEmail.includes('@')) { alert('请输入有效邮箱'); return; }
    if (!verifyCode || verifyCode.length !== 6) { alert('请输入6位验证码'); return; }
    if (bindPin.length < 6) { alert('支付密码至少6位'); return; }
    
    setWalletLoading(true);
    try {
      const res = await axiosClient.post('/wallet/bind', { 
        email: bindEmail, 
        pin: bindPin,
        code: verifyCode 
      });
      
      if (res.data?.success) {
        alert('✅ 账户合并成功！');
        
        // 关键：立即重新获取所有状态，不要等 useEffect！
        await fetchWalletStatus();
        await fetchWalletBalance();
        await fetchWalletTxs();
        
        // 清空表单
        setBindEmail('');
        setVerifyCode('');
        setBindPin('');
      }
    } catch (e: any) {
      alert('合并失败：' + (e.response?.data?.error || '未知错误'));
    } finally {
      setWalletLoading(false);
    }
  };

  const handleTransfer = async () => {
    if (!transferTo.trim() || !transferAmount) { alert('请输入对方UID和金额'); return; }
    try {
      const res = await axiosClient.post('/wallet/transfer', {
        to_uid: transferTo.trim(),
        amount: parseFloat(transferAmount),
        remark: transferRemark,
        pin: transferPin  // ← 添加这一行
      });
      if (res.data?.success) {
        alert('✅ 转账成功！');
        setTransferTo(''); setTransferAmount(''); setTransferRemark('');
        setWalletSubPage('main');
        fetchWalletBalance();
        fetchWalletTxs();
      }
    } catch (e: any) {
      alert('转账失败：' + (e.response?.data?.error || '未知错误'));
    }
  };

  const handleWithdrawApply = async () => {
    if (!withdrawAmount || !withdrawAddress) { alert('请输入金额和Pi钱包地址'); return; }
    try {
      const res = await axiosClient.post('/wallet/withdraw-apply', {
        amount: parseFloat(withdrawAmount),
        piWalletAddress: withdrawAddress
      });
      if (res.data?.success) {
        alert('✅ ' + res.data.message);
        setWithdrawAmount(''); setWithdrawAddress('');
        setWalletSubPage('main');
        fetchWalletBalance();
        fetchWalletTxs();
      }
    } catch (e: any) {
      alert('提现申请失败：' + (e.response?.data?.error || '未知错误'));
    }
  };

  const handlePiRecharge = async () => {
    const amount = rechargeAmount > 0 ? rechargeAmount : parseFloat(customAmount);
    if (!amount || amount <= 0) { alert('请输入充值金额'); return; }

    const Pi = window.Pi;
    if (!Pi) { alert('请在 Pi Browser 中打开'); return; }

    setPiRecharging(true);
    try {
      await Pi.createPayment({
        amount: amount,
        memo: `钱包充值 π${amount}`,
        metadata: { type: 'wallet_recharge', user_uid: user?.uid, amount }
      }, {
        onReadyForServerApproval: async (paymentId: string) => {
          await axiosClient.post('/payments/approve', { paymentId });
        },
        onReadyForServerCompletion: async (paymentId: string, txid: string) => {
          await axiosClient.post('/payments/complete', { 
            paymentId, txid, type: 'wallet_recharge',
            user_uid: user?.uid, amount
          });
          alert('充值成功！');
          fetchWalletBalance();
          fetchWalletTxs();
          setRechargeAmount(0);
          setCustomAmount('');
        },
        onCancel: () => { alert('支付已取消'); },
        onError: (error: any) => { console.error('Pi recharge error:', error); alert('支付失败'); }
      });
    } catch (e: any) {
      alert(e?.message || '支付失败');
    } finally {
      setPiRecharging(false);
    }
  };

  useEffect(() => {
    if (subPage === 'merchant-orders' && merchantStatus === 'approved') {
      fetchMerchantOrders();
    }
  }, [subPage, orderFilter, selectedMerchantId]);


  useEffect(() => {
    if (subPage === 'merchant-finance' && merchantStatus === 'approved') {
      fetchFinance();
      fetchTransactions();
      fetchWithdrawals();
    }
  }, [subPage, selectedMerchantId]);
  
  useEffect(() => {
    if (subPage === 'merchant-stats' && merchantStatus === 'approved') {
      fetchMerchantStats();
      fetchProductRanking();
    }
  }, [subPage, selectedMerchantId]);

  useEffect(() => {
    if (merchantStatus === 'approved') {
      fetchMerchantCoupons();
    }
  }, [merchantStatus]);

  useEffect(() => {
    if (subPage === 'orders' && user) fetchOrders();
    if (subPage === 'favorites' && user) fetchFavorites();
    if (subPage === 'coupons' && user) fetchCoupons();
    if (subPage === 'address' && user) fetchAddresses();
    if (subPage === 'notifications' && user) fetchNotifications();
    // ===== 新增这两行 =====
    if (subPage === 'claim-coupons' && user) {
      fetchAvailableCoupons();
      fetchUserCoupons();
    }
  }, [subPage]);

  useEffect(() => {
    if (user) fetchUnreadCount();
  }, [user]);
  useEffect(() => {
    if (subPage === 'merchant' && merchantStatus === 'approved') {
      axiosClient.get(`/merchants/products?merchant_id=${selectedMerchantId}`).then((res: any) => {
        setMyProducts(res.data.products || []);
      }).catch(() => {});
      fetchCategories();  // ← 添加这一行
    }
  }, [subPage, merchantStatus]);

  useEffect(() => {
    if (user) {
      axiosClient.get('/merchants/me').then((res: any) => {
        const list = res.data.merchants || [];
        setMerchants(list);
        
        // 自动选中第一个已批准的店铺，或第一个店铺
        const approved = list.find((m: any) => m.status === 'approved');
        const first = list[0];
        const target = approved || first;
        if (target) {
          setSelectedMerchantId(String(target.id));
          setMerchantStatus(target.status);
          setStoreForm({
            logo: target.logo || '',
            announcement: target.announcement || '',
            business_hours: target.business_hours ? JSON.parse(target.business_hours) : { open: true }
          });
          if (target.reject_reason) {
            setRejectReason(target.reject_reason);
          }
        } else {
          setMerchantStatus(null);
        }
      }).catch(() => {});
    }
  }, [user]);
  
    // 切换店铺时，自动刷新当前页面的数据
  useEffect(() => {
    if (!selectedMerchantId || merchantStatus !== 'approved') return;  
    if (subPage === 'merchant') {
      axiosClient.get(`/merchants/products?merchant_id=${selectedMerchantId}`).then((res: any) => {
        setMyProducts(res.data.products || []);
      }).catch(() => {});
    }
    
    if (subPage === 'merchant-orders') {
      const f = orderFilter;
      axiosClient.get(`/merchants/orders?status=${f}&merchant_id=${selectedMerchantId}`).then((res: any) => {
        setMerchantOrders(res.data.orders || []);
      }).catch((e: any) => console.log('fetch orders error', e));
    }
    
    if (subPage === 'merchant-finance') {
      axiosClient.get(`/merchants/finance?merchant_id=${selectedMerchantId}`).then((res: any) => setFinanceData(res.data.finance)).catch(() => {});
      axiosClient.get(`/merchants/transactions?merchant_id=${selectedMerchantId}`).then((res: any) => setTransactions(res.data.transactions || [])).catch(() => {});
      axiosClient.get(`/merchants/withdrawals?merchant_id=${selectedMerchantId}`).then((res: any) => setWithdrawals(res.data.withdrawals || [])).catch(() => {});
    }
    
    if (subPage === 'merchant-stats') {
      axiosClient.get(`/merchants/stats?merchant_id=${selectedMerchantId}`).then((res: any) => setMerchantStats(res.data.stats)).catch(() => {});
      axiosClient.get(`/merchants/stats/products?merchant_id=${selectedMerchantId}`).then((res: any) => setProductRanking(res.data.products || [])).catch(() => {});
    }
  }, [selectedMerchantId, subPage, merchantStatus, orderFilter]);

  // 在页面加载时查询钱包状态
  useEffect(() => {
    const checkWallet = async () => {
      try {
        const res = await axiosClient.get('/wallet/status');
        if (res.data?.bound) {
          const balRes = await axiosClient.get('/wallet/balance');
          setWalletInfo({
            bound: true,
            balances: balRes.data?.balances || []
          });
        }
      } catch (e) {}
    };
    checkWallet();
  }, []);

      // 进入钱包页面时自动获取状态
  useEffect(() => {
    if (subPage === 'wallet') {
      console.log('Entering wallet, fetching data...'); // 调试用
      const timer = setTimeout(() => {
        fetchWalletStatus();
        fetchWalletBalance();  // ← 确保这行存在
        fetchWalletTxs();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [subPage]);
 
  const getProductName = (productId: string) => {
    const product = products.find(p => p.id === productId);
    return product ? product.name : productId;
  };

  const getProductPrice = (productId: string) => {
    const product = products.find(p => p.id === productId);
    return product ? product.piPrice : 0;
  };

  const getStatusText = (order: Order) => {
    if (order.refunded) return t('order.refunded');
    if (order.cancelled) return t('order.cancelled');
    if (order.paid) return t('order.completed');
    return t('order.pending');
  };

  const getStatusBadge = (order: Order) => {
    if (order.refunded) return 'badge-blue';
    if (order.cancelled) return 'badge-red';
    if (order.paid) return 'badge-green';
    return 'badge-yellow';
  };

    const menuItems = [
    { icon: '📦', text: t('mine.orders'), page: 'orders' },
    { icon: '💰', text: t('mine.wallet'), page: 'wallet' },
    { icon: '🎫', text: t('mine.coupons'), page: 'coupons' },
    { icon: '📍', text: t('mine.address'), page: 'address' },
    { icon: '❤️', text: t('mine.favorites'), page: 'favorites' },
    { icon: '📜', text: t('mine.history'), page: 'history' },
    { icon: '🔔', text: t('notif.title'), page: 'notifications', badge: unreadCount },
    { icon: '⚙️', text: t('mine.settings'), page: 'settings' },
    { icon: '🏪', text: merchantStatus === 'approved' ? t('merchant.myStore') : t('merchant.apply'), page: 'merchant' },
    { icon: '📋', text: t('merchant.orders'), page: 'merchant-orders' },
    { icon: '💰', text: t('merchant.income'), page: 'merchant-finance' },
    { icon: '📊', text: t('stats.title'), page: 'merchant-stats' },
    { icon: '🎫', text: t('merchant.coupons') || 'My Coupons', page: 'merchant-coupons' },
    { icon: '💬', text: t('mine.service'), page: 'service' },
    { icon: '🎁', text: t('coupon.claimCenter'), page: 'claim-coupons' },
  ];

  const renderOrderList = (filter: string) => {
    let filtered = orders
    if (filter === 'pending') filtered = orders.filter(o => !o.paid && !o.cancelled);
    else if (filter === 'completed') filtered = orders.filter(o => o.paid && !o.refunded);
    else if (filter === 'cancelled') filtered = orders.filter(o => o.cancelled || o.refunded);

    if (filtered.length === 0) {
      return (
        <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
          <div style={{fontSize:48}}>📦</div>
          <p>{t('mine.noOrders')}</p>
        </div>
      );
    }

    return (
      <div style={{padding:'12px'}}>
        {filtered.map((order) => (
          <div key={order.id} style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}} onClick={() => { setSelectedOrder(order); setSubPage('order-detail'); }}>
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'8px'}}>
              <span style={{fontWeight:'bold', flex:1}}>{getProductName(order.product_id)}</span>
              <span className={`badge ${getStatusBadge(order)}`}>{getStatusText(order)}</span>
            </div>
            <div style={{display:'flex', justifyContent:'space-between', color:'#666', fontSize:'14px'}}>
              <span>π{getProductPrice(order.product_id)}</span>
              <span>{order.created_at ? new Date(order.created_at).toLocaleDateString() : '-'}</span>
            </div>
            {/* 物流状态标签 */}
            {order.paid && !order.cancelled && !order.refunded && (
              <div style={{marginTop:'8px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span style={{fontSize:'12px', color: order.shipping_status === 'completed' ? '#4caf50' : order.shipping_status === 'shipped' ? '#2196f3' : '#ff9800'}}>
                  {order.refund_status === 'pending' ? '💸 ' + t('mo.refundPending') :
                   order.shipping_status === 'completed' ? '✅ ' + t('mo.completed') :
                   order.shipping_status === 'shipped' ? '🚚 ' + t('mo.shipped') :
                   '📦 ' + t('mo.pendingShip')}
                </span>
                <span style={{fontSize:'11px', color:'#611f69'}}>› {t('bo.viewDetail')}</span>
              </div>
            )}
            <div style={{fontSize:'11px', color:'#999', marginTop:'6px'}}>
              {t('mine.orderNum')} #{order.id} · {t('mine.payment')}: {order.pi_payment_id ? order.pi_payment_id.slice(0, 16) + '...' : '-'}
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (subPage === 'orders') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('mine.orders')}</span>
          <span style={{width:36}}></span>
        </div>
        {renderOrderList('all')}
      </div>
    );
  }

  if (subPage === 'history') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('mine.history')}</span>
          <span style={{width:36}}></span>
        </div>
        {renderOrderList('completed')}
      </div>
    );
  }

  // ==================== 收藏页面 ====================
  if (subPage === 'favorites') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('mine.favorites')}</span>
          <span style={{width:36}}></span>
        </div>
        {favorites.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>❤️</div>
            <p>{t('mine.noFavorites')}</p>
          </div>
        ) : (
          <div className="product-grid" style={{padding:'12px'}}>
            {favorites.map((f: any) => f.product && (
              <div className="product-card" key={f.id} onClick={() => {}}>
                <img src={f.product.image} alt={f.product.name} style={{width:'100%', height:'140px', objectFit:'cover'}} onError={(e: any) => e.target.src='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180"><rect fill="%23f0f0f0" width="200" height="180"/><text x="100" y="95" text-anchor="middle" fill="%23ccc" font-size="14">No Image</text></svg>'} />
                <div className="product-card-info">
                  <div className="product-card-name">{f.product.name}</div>
                  <div className="product-card-prices">
                    <span className="pi-price">{f.product.piPrice}</span>
                  </div>
                  <button onClick={async (e) => { e.stopPropagation(); await axiosClient.delete(`/favorites/${f.product.id}`); fetchFavorites(); }} style={{marginTop:'4px', padding:'2px 8px', borderRadius:'4px', border:'1px solid #ff4444', color:'#ff4444', background:'white', fontSize:'11px', cursor:'pointer'}}>{t('fav.remove')}</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==================== 优惠券页面 ====================
  if (subPage === 'coupons') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('mine.coupons')}</span>
          <span style={{width:36}}></span>
        </div>
        <div style={{padding:'16px', background:'#fff', margin:'12px', borderRadius:'12px'}}>
          <div style={{display:'flex', gap:'8px'}}>
            <input 
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder={t('coupon.code')}
              style={{flex:1, padding:'8px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none'}}
            />
            <button 
              onClick={async () => {
                if (!couponCode.trim()) return;
                try {
                  await axiosClient.post('/coupons/claim', { code: couponCode.trim() });
                  setCouponCode('');
                  fetchCoupons();
                  alert(t('coupon.claimed'));
                } catch (e: any) {
                  const msg = e.response?.data?.error;
                  if (msg === 'Coupon expired') alert(t('coupon.expired'));
                  else alert(t('coupon.invalid'));
                }
              }}
              style={{padding:'8px 16px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer', whiteSpace:'nowrap'}}
            >{t('coupon.claim')}</button>
          </div>
        </div>
        {coupons.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🎫</div>
            <p>{t('mine.noCoupons')}</p>
          </div>
        ) : (
          <div style={{padding:'0 12px'}}>
            {coupons.map((c: any) => (
              <div key={c.id} style={{background:'linear-gradient(135deg, #611f69, #9b59b6)', borderRadius:'12px', padding:'16px', marginBottom:'10px', color:'white', position:'relative', overflow:'hidden'}}>
                <div style={{fontSize:'24px', fontWeight:'bold'}}>{c.discount}{t('coupon.discount')}</div>
                <div style={{fontSize:'12px', opacity:0.8, marginTop:'4px'}}>{t('coupon.minOrder')}: π{c.min_order || 0}</div>
                <div style={{fontSize:'11px', opacity:0.6, marginTop:'4px'}}>{c.code}</div>
                {c.used ? <div style={{position:'absolute', right:'16px', top:'50%', transform:'translateY(-50%)', fontSize:'14px', opacity:0.6}}>USED</div> : null}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==================== 收货地址页面 ====================
  if (subPage === 'address') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('mine.address')}</span>
          <span style={{width:36}}></span>
        </div>
        <div style={{padding:'16px', background:'#fff', margin:'12px', borderRadius:'12px'}}>
          <div style={{marginBottom:'8px'}}>
            <input value={addrForm.name} onChange={(e) => setAddrForm({...addrForm, name: e.target.value})} placeholder={t('addr.name')} style={{width:'100%', padding:'8px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
            <input value={addrForm.phone} onChange={(e) => setAddrForm({...addrForm, phone: e.target.value})} placeholder={t('addr.phone')} style={{width:'100%', padding:'8px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
            <input value={addrForm.address} onChange={(e) => setAddrForm({...addrForm, address: e.target.value})} placeholder={t('addr.detail')} style={{width:'100%', padding:'8px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
            <label style={{display:'flex', alignItems:'center', gap:'6px', fontSize:'13px', color:'#666'}}>
              <input type="checkbox" checked={addrForm.is_default} onChange={(e) => setAddrForm({...addrForm, is_default: e.target.checked})} />
              {t('addr.setDefault')}
            </label>
          </div>
          <button 
            onClick={async () => {
              if (!addrForm.name || !addrForm.phone || !addrForm.address) return;
              try {
                if (editingAddrId) {
                  await axiosClient.patch(`/addresses/${editingAddrId}`, addrForm);
                  setEditingAddrId(null);
                } else {
                  await axiosClient.post('/addresses', addrForm);
                }
                setAddrForm({ name: '', phone: '', address: '', is_default: false });
                fetchAddresses();
              } catch (e) {}
            }}
            style={{width:'100%', padding:'10px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}
          >{editingAddrId ? t('addr.edit') : t('addr.add')}</button>
          {editingAddrId && (
            <button onClick={() => { setEditingAddrId(null); setAddrForm({ name: '', phone: '', address: '', is_default: false }); }} style={{width:'100%', padding:'10px', marginTop:'8px', background:'#eee', color:'#333', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>{t('cancel')}</button>
          )}
        </div>
        {addresses.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>📍</div>
            <p>{t('mine.noAddress')}</p>
          </div>
        ) : (
          <div style={{padding:'0 12px'}}>
            {addresses.map((a: any) => (
              <div key={a.id} style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <div>
                    <span style={{fontWeight:'bold'}}>{a.name}</span>
                    <span style={{color:'#666', marginLeft:'12px'}}>{a.phone}</span>
                    {a.is_default ? <span style={{marginLeft:'8px', fontSize:'11px', color:'#611f69', border:'1px solid #611f69', borderRadius:'4px', padding:'1px 6px'}}>{t('addr.default')}</span> : null}
                  </div>
                </div>
                <div style={{color:'#666', fontSize:'13px', marginTop:'6px'}}>{a.address}</div>
                <div style={{display:'flex', gap:'12px', marginTop:'8px'}}>
                  <span style={{color:'#611f69', fontSize:'12px', cursor:'pointer'}} onClick={() => { setAddrForm({ name: a.name, phone: a.phone, address: a.address, is_default: !!a.is_default }); setEditingAddrId(String(a.id)); }}>{t('addr.edit')}</span>
                  <span style={{color:'#ff4444', fontSize:'12px', cursor:'pointer'}} onClick={async () => { await axiosClient.delete(`/addresses/${a.id}`); fetchAddresses(); }}>{t('addr.delete')}</span>
                  {!a.is_default && <span style={{color:'#666', fontSize:'12px', cursor:'pointer'}} onClick={async () => { await axiosClient.patch(`/addresses/${a.id}`, { is_default: true }); fetchAddresses(); }}>{t('addr.setDefault')}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==================== 通知页面 ====================
  if (subPage === 'notifications') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('notif.title')}</span>
          <span style={{width:36}}></span>
        </div>
        {notifications.length > 0 && (
          <div style={{padding:'12px 16px', textAlign:'right'}}>
            <span style={{color:'#611f69', fontSize:'13px', cursor:'pointer'}} onClick={async () => { await axiosClient.post('/notifications/read-all'); fetchNotifications(); fetchUnreadCount(); }}>{t('notif.readAll')}</span>
          </div>
        )}
        {notifications.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🔔</div>
            <p>{t('notif.empty')}</p>
          </div>
        ) : (
          <div style={{padding:'0 12px'}}>
            {notifications.map((n: any) => (
              <div key={n.id} style={{background: n.read ? '#fff' : '#f8f5ff', borderRadius:'12px', padding:'16px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}} onClick={async () => { if (!n.read) { await axiosClient.patch(`/notifications/${n.id}/read`); fetchNotifications(); fetchUnreadCount(); } }}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <span style={{fontWeight: n.read ? 400 : 600, fontSize:'14px'}}>{n.title}</span>
                  {!n.read && <span style={{width:'8px', height:'8px', borderRadius:'50%', background:'#611f69'}}></span>}
                </div>
                <div style={{color:'#666', fontSize:'13px', marginTop:'6px'}}>{n.content}</div>
                <div style={{color:'#999', fontSize:'11px', marginTop:'6px'}}>{n.created_at ? new Date(n.created_at).toLocaleString() : ''}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==================== 占位页面 ====================
  const renderPlaceholder = (icon: string, title: string, message: string) => (
    <div>
      <div className="detail-header">
        <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
        <span className="detail-title">{title}</span>
        <span style={{width:36}}></span>
      </div>
      <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
        <div style={{fontSize:48}}>{icon}</div>
        <p>{message}</p>
      </div>
    </div>
  );
  // ==================== 商家入驻页面 ====================
  if (subPage === 'merchant') {
    if (merchantStatus === 'approved') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('merchant.dashboard')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'20px'}}>
            {currentMerchant?.logo?.trim() ? (
              <img src={currentMerchant.logo} style={{width:'64px', height:'64px', borderRadius:'50%', objectFit:'cover', margin:'0 auto'}} onError={(e: any) => e.target.style.display='none'} />
            ) : (
              <div style={{
                width:'64px', height:'64px', borderRadius:'50%',
                margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'center',
                fontSize:'28px', fontWeight:'bold', color:'#fff',
                background: BRAND_COLORS[(currentMerchant?.id || 0) % BRAND_COLORS.length]
              }}>
                {currentMerchant?.name?.charAt(0).toUpperCase() || '店'}
              </div>
            )}
            <h3 style={{marginTop:'8px', color:'#611f69'}}>{currentMerchant?.name || t('merchant.welcome')}</h3>
            
            {/* 多店铺切换 */}
            {approvedMerchants.length > 1 && (
              <select 
                value={selectedMerchantId || ''} 
                onChange={(e) => {
                  const id = e.target.value;
                  setSelectedMerchantId(id);
                  const m = merchants.find((x: any) => String(x.id) === id);
                  if (m) {
                    setStoreForm({
                      logo: m.logo || '',
                      announcement: m.announcement || '',
                      business_hours: m.business_hours ? JSON.parse(m.business_hours) : { open: true }
                    });
                  }
                }}
                style={{marginTop:'12px', padding:'8px 12px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'13px', outline:'none'}}
              >
                {approvedMerchants.map((m: any) => (
                  <option key={m.id} value={String(m.id)}>{m.name}</option>
                ))}
              </select>
            )}
          </div>
          <div style={{padding:'0 16px', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px', marginBottom:'16px'}}>
            <div style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'24px'}}>📦</div>
              <div style={{fontSize:'12px', color:'#666', marginTop:'4px'}}>{myProducts.length} {t('mp.myProducts')}</div>
            </div>
            <div onClick={() => setSubPage('merchant-orders')} style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}}>
              <div style={{fontSize:'24px'}}>📋</div>
              <div style={{fontSize:'12px', color:'#666', marginTop:'4px'}}>{t('merchant.orders')}</div>
            </div>
            <div onClick={() => setSubPage('merchant-stats')} style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}}>
              <div style={{fontSize:'24px'}}>📊</div>
              <div style={{fontSize:'12px', color:'#611f69', marginTop:'4px'}}>{t('stats.title')} ›</div>
            </div>
            <div onClick={() => setSubPage('merchant-finance')} style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}}>
              <div style={{fontSize:'24px'}}>💰</div>
              <div style={{fontSize:'12px', color:'#611f69', marginTop:'4px'}}>{t('merchant.income')} ›</div>
            </div>
            <div onClick={() => setSubPage('merchant-store-edit')} style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}}>
              <div style={{fontSize:'24px'}}>🎨</div>
              <div style={{fontSize:'12px', color:'#611f69', marginTop:'4px'}}>{t('store.update')} ›</div>
            </div>
            {canCreateStore && (
              <div onClick={() => {
                setMName(''); setMContact(''); setMPhone(''); setEmail(''); setMDesc('');
                setIdCardFront(''); setIdCardBack(''); setBusinessLicense(''); setLegalIdCard('');
                setMerchantType('personal'); setCountry('CN'); setMAgree(false);
                setMerchantStatus(null);
              }} style={{background:'#fff', borderRadius:'12px', padding:'16px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', cursor:'pointer'}}>
                <div style={{fontSize:'24px'}}>➕</div>
                <div style={{fontSize:'12px', color:'#611f69', marginTop:'4px'}}>{t('merchant.newStore')} ›</div>
                <div style={{fontSize:'10px', color:'#999', marginTop:'2px'}}>
                  {t('merchant.storeCount').replace('{current}', String(approvedMerchants.length)).replace('{max}', String(currentMerchant?.merchant_type === 'enterprise' ? 5 : 2))}
                </div>
              </div>
            )}
          </div>
          <div style={{padding:'0 16px', marginBottom:'12px'}}>
            <button onClick={() => { 
              setPForm({ name: '', image: '', piPrice: '', originalPrice: '', category: '', description: '', stock: '', coupon: '', skus: [] });
              setEditProductId(null); 
              setShowProductForm(!showProductForm); 
            }} style={{width:'100%', padding:'12px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>
              + {t('mp.add')}
            </button>
          </div>
          
          {/* 批量导入按钮 */}
         {!showImportModal && (
            <div style={{padding:'0 16px', marginBottom:'12px'}}>
              <button onClick={() => setShowImportModal(true)}>
                📥 批量导入
              </button>
            </div>
          )}

          {showProductForm && (
            <div style={{padding:'0 16px', marginBottom:'12px'}}>

                    {/* 链接解析辅助录入 */}
              <div style={{marginBottom:'16px', padding:'12px', background:'#f3e5f5', borderRadius:'8px'}}>
                <div style={{fontSize:'13px', fontWeight:600, color:'#611f69', marginBottom:'8px'}}>
                  🔗 快速录入（粘贴商品链接自动填充）
                </div>
                <div style={{display:'flex', gap:'8px'}}>
                  <input
                    type="text"
                    placeholder="粘贴淘宝/京东/亚马逊/1688 等商品链接"
                    value={parseUrl}
                    onChange={(e) => setParseUrl(e.target.value)}
                    style={{
                      flex:1,
                      padding:'8px 12px',
                      border:'1px solid #ddd',
                      borderRadius:'6px',
                      fontSize:'13px'
                    }}
                  />
                  <button
                    onClick={handleParseLink}
                    disabled={parsing || !parseUrl.trim()}
                    style={{
                      padding:'8px 16px',
                      background: parsing ? '#ccc' : '#611f69',
                      color:'#fff',
                      border:'none',
                      borderRadius:'6px',
                      cursor: parsing ? 'not-allowed' : 'pointer',
                      fontSize:'13px',
                      whiteSpace:'nowrap'
                    }}
                  >
                    {parsing ? '解析中...' : '一键填充'}
                  </button>
                </div>
              </div>

                            {/* 商品表单 */}
              <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                <h3 style={{marginBottom:'12px', color:'#611f69'}}>{editProductId ? t('mp.edit') : t('mp.add')}</h3>
                
                <input value={pForm.name} onChange={(e) => setPForm({...pForm, name: e.target.value})} placeholder={t('mp.name')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
                
                <input 
                  value={pForm.image} 
                  onChange={(e) => setPForm({...pForm, image: e.target.value})} 
                  placeholder={t('mp.image')} 
                  style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'4px'}} 
                />
                <div style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px'}}>
                  <input 
                    type="file" 
                    accept="image/*" 
                    onChange={handleImageUpload}
                    style={{fontSize:'13px'}}
                  />
                  {uploadingImage && <span style={{color:'#611f69', fontSize:'12px'}}>上传中...</span>}
                </div>
                {pForm.image && (
                  <img 
                    src={pForm.image}
                    alt="预览" 
                    style={{width:'80px', height:'80px', objectFit:'cover', borderRadius:'8px', border:'1px solid #eee', marginBottom:'4px'}} 
                    onError={(e: any) => e.target.style.display='none'}
                  />
                )}
                <div style={{fontSize:'12px', color:'#999', lineHeight:'1.4', marginBottom:'8px'}}>
                  💡 {t('mp.imageTip')}<br/>
                  <span style={{fontSize:'11px'}}>推荐：imgur.com / postimages.org / sm.ms</span>
                </div>

                {/* 链接解析辅助录入 */}
                <div style={{marginBottom:'12px', padding:'12px', background:'#f3e5f5', borderRadius:'8px'}}>
                  <div style={{fontSize:'13px', fontWeight:600, color:'#611f69', marginBottom:'8px'}}>
                    🔗 快速录入（粘贴商品链接自动填充）
                  </div>
                  <div style={{display:'flex', gap:'8px'}}>
                    <input
                      type="text"
                      placeholder="粘贴淘宝/京东/亚马逊/1688 等商品链接"
                      value={parseUrl}
                      onChange={(e) => setParseUrl(e.target.value)}
                      style={{
                        flex:1,
                        padding:'8px 12px',
                        border:'1px solid #ddd',
                        borderRadius:'6px',
                        fontSize:'13px'
                      }}
                    />
                    <button
                      onClick={handleParseLink}
                      disabled={parsing || !parseUrl.trim()}
                      style={{
                        padding:'8px 16px',
                        background: parsing ? '#ccc' : '#611f69',
                        color:'#fff',
                        border:'none',
                        borderRadius:'6px',
                        cursor: parsing ? 'not-allowed' : 'pointer',
                        fontSize:'13px',
                        whiteSpace:'nowrap'
                      }}
                    >
                      {parsing ? '解析中...' : '一键填充'}
                    </button>
                  </div>
                </div>

                {/* 单规格时显示：价格 + 原价 */}
                {pForm.skus.length === 0 && (
                  <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                    <input value={pForm.piPrice} onChange={(e) => setPForm({...pForm, piPrice: e.target.value})} placeholder={t('mp.price')} type="number" step="0.01" style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box'}} />
                    <input value={pForm.originalPrice} onChange={(e) => setPForm({...pForm, originalPrice: e.target.value})} placeholder={t('mp.originalPrice')} type="number" style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box'}} />
                  </div>
                )}

                {/* 分类 + 库存（单规格时显示库存，多规格时隐藏） */}
                <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                  <select 
                    value={pForm.category} 
                    onChange={(e) => setPForm({...pForm, category: e.target.value})} 
                    style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', background:'#fff', height:'42px'}}
                  >
                    <option value="">{t('mp.category')}</option>
                    {categoryList.map((c: any) => (
                      <option key={c.slug || c.name} value={c.name}>
                        {c.icon || ''} {t('cat.' + (c as any).slug) || c.name}
                      </option>
                    ))}
                  </select>
                  {pForm.skus.length === 0 && (
                    <input value={pForm.stock} onChange={(e) => setPForm({...pForm, stock: e.target.value})} placeholder={t('mp.stock')} type="number" style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box'}} />
                  )}
                </div>

                {/* SKU 规格管理 */}
                <div style={{marginBottom:'12px', padding:'12px', background:'#f8f9fa', borderRadius:'8px'}}>
                  <div style={{fontSize:'13px', fontWeight:600, color:'#333', marginBottom:'8px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <span>📦 SKU 规格（多规格商品）</span>
                    {pForm.skus.length > 0 && <span style={{fontSize:'11px', color:'#888', fontWeight:'normal'}}>已添加 SKU，上方价格/库存失效</span>}
                  </div>
                  
                  {pForm.skus.map((sku, idx) => (
                    <div key={idx} style={{marginBottom:'10px', padding:'10px', background:'#fff', borderRadius:'6px', border:'1px solid #e0e0e0'}}>
                      <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                        <input 
                          placeholder="规格名称（如：黑色-128GB）"
                          value={sku.spec_name || ''}
                          onChange={e => {
                            const newSkus = [...pForm.skus];
                            newSkus[idx] = {...newSkus[idx], spec_name: e.target.value};
                            setPForm({...pForm, skus: newSkus});
                          }}
                          style={{flex:1, padding:'8px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'13px'}}
                        />
                        <button 
                          type="button"
                          onClick={() => {
                            const newSkus = pForm.skus.filter((_, i) => i !== idx);
                            setPForm({...pForm, skus: newSkus});
                          }}
                          style={{padding:'8px 12px', background:'#ffebee', color:'#c62828', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'12px'}}
                        >
                          删除
                        </button>
                      </div>
                      <div style={{display:'flex', gap:'8px'}}>
                        <input 
                          placeholder="Pi价格"
                          type="number"
                          value={sku.piPrice || ''}
                          onChange={e => {
                            const newSkus = [...pForm.skus];
                            newSkus[idx] = {...newSkus[idx], piPrice: e.target.value};
                            setPForm({...pForm, skus: newSkus});
                          }}
                          style={{flex:1, padding:'8px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'13px'}}
                        />
                        <input 
                          placeholder="库存"
                          type="number"
                          value={sku.stock || ''}
                          onChange={e => {
                            const newSkus = [...pForm.skus];
                            newSkus[idx] = {...newSkus[idx], stock: e.target.value};
                            setPForm({...pForm, skus: newSkus});
                          }}
                          style={{flex:1, padding:'8px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'13px'}}
                        />
                      </div>
                    </div>
                  ))}
                  
                  <button 
                    type="button"
                    onClick={() => setPForm({...pForm, skus: [...pForm.skus, {spec_name:'', piPrice:'', stock:'', image:'', spec_json:{}}]})}
                    style={{padding:'8px 16px', background:'#e3f2fd', color:'#1565c0', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'13px', width:'100%'}}
                  >
                    + 添加规格
                  </button>
                  
                  <div style={{marginTop:'8px', fontSize:'11px', color:'#888'}}>
                    如果不添加 SKU，商品将以单规格形式售卖
                  </div>
                </div>

                <textarea value={pForm.description} onChange={(e) => setPForm({...pForm, description: e.target.value})} placeholder={t('mp.description')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px', height:'60px', resize:'none'}} />
                <input value={pForm.coupon} onChange={(e) => setPForm({...pForm, coupon: e.target.value})} placeholder="Coupon" style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
                <div style={{display:'flex', gap:'8px'}}>
                  <button onClick={async () => {
                    if (!pForm.name.trim()) { alert('请输入商品名称'); return; }
                    if (pForm.skus.length === 0 && (!pForm.piPrice.trim() || isNaN(parseFloat(pForm.piPrice)))) { alert('请输入有效的商品价格'); return; }
                    if (pForm.skus.length > 0 && pForm.skus.some((s: any) => !s.spec_name || !s.piPrice)) { alert('请完善所有SKU的规格名称和价格'); return; }
                    
                    try {
                      const body = {
                        name: pForm.name.trim(),
                        image: pForm.image.trim(),
                        piPrice: parseFloat(pForm.piPrice),
                        originalPrice: parseFloat(pForm.originalPrice) || 0,
                        category: pForm.category,
                        description: pForm.description,
                        stock: parseInt(pForm.stock) || 0,
                        coupon: pForm.coupon,
                        skus: pForm.skus.filter((s: any) => s.spec_name && s.piPrice).map((s: any) => ({
                          spec_name: s.spec_name,
                          spec_json: {规格: s.spec_name},
                          piPrice: parseFloat(s.piPrice),
                          originalPrice: parseFloat(pForm.originalPrice) || 0,
                          stock: parseInt(s.stock) || 0,
                          image: s.image || pForm.image
                        }))
                      };
                      
                      if (editProductId) {
                        await axiosClient.patch(`/merchants/products/${editProductId}?merchant_id=${selectedMerchantId}`, body);
                        alert('商品修改成功');
                      } else {
                        await axiosClient.post(`/merchants/products?merchant_id=${selectedMerchantId}`, body);
                        alert('商品添加成功');
                      }
                      
                      setShowProductForm(false);
                      setEditProductId(null);
                      setPForm({ name: '', image: '', piPrice: '', originalPrice: '', category: '', description: '', stock: '', coupon: '', skus: [] });
                      
                      const res = await axiosClient.get('/merchants/products');
                      setMyProducts(res.data.products || []);
                    } catch (err: any) {
                      const msg = err.response?.data?.error || err.message || '操作失败';
                      alert('操作失败: ' + msg);
                      console.error('Add/Edit product error:', err);
                    }
                  }} style={{flex:1, padding:'10px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>{editProductId ? t('mp.edit') : t('mp.add')}</button>
                  <button onClick={() => { setShowProductForm(false); setEditProductId(null); }} style={{padding:'10px 16px', background:'#eee', color:'#333', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>{t('cancel')}</button>
                </div>
              </div>
            </div>
          )}
          <div style={{padding:'0 16px'}}>
            <h3 style={{marginBottom:'8px'}}>{t('mp.myProducts')}</h3>
            {myProducts.length === 0 ? (
              <div style={{textAlign:'center', padding:'30px', color:'#999'}}>{t('mp.noProducts')}</div>
            ) : myProducts.map((p: any) => (
              <div key={p.id} style={{background:'#fff', borderRadius:'12px', padding:'12px', marginBottom:'10px', display:'flex', gap:'12px', alignItems:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <img src={p.image} alt={p.name} style={{width:'60px', height:'60px', objectFit:'cover', borderRadius:'8px'}} onError={(e: any) => e.target.src='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect fill="%23f0f0f0" width="80" height="80"/><text x="40" y="45" text-anchor="middle" fill="%23ccc" font-size="12">No Image</text></svg>'} />
                <div style={{flex:1}}>
                  <div style={{fontSize:'14px', fontWeight:500}}>{p.name}</div>
                  <div style={{fontSize:'13px', color:'#611f69', fontWeight:'bold', marginTop:'4px'}}>π{p.piPrice}</div>
                  <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{p.stock || 0} {t('mp.stockLeft')}</div>
                </div>
                <div style={{display:'flex', flexDirection:'column', gap:'4px'}}>
                  <button onClick={async () => { await axiosClient.patch(`/merchants/products/${p.id}?merchant_id=${selectedMerchantId}`, { published: p.published ? 0 : 1 }); const res = await axiosClient.get(`/merchants/products?merchant_id=${selectedMerchantId}`); setMyProducts(res.data.products || []); }} style={{padding:'4px 8px', borderRadius:'4px', border:'1px solid #611f69', color:'#611f69', background:'white', fontSize:'11px', cursor:'pointer'}}>{p.published ? t('mp.hidden') : t('mp.published')}</button>
                  <button onClick={() => { 
                    setPForm({ 
                      name: p.name, 
                      image: p.image || '', 
                      piPrice: String(p.piPrice), 
                      originalPrice: String(p.originalPrice), 
                      category: p.category || '', 
                      description: p.description || '', 
                      stock: String(p.stock || 0), 
                      coupon: p.coupon || '',
                      skus: p.skus || []  // ← 加上这行
                    }); 
                    setEditProductId(String(p.id)); 
                    setShowProductForm(true); 
                  }} style={{padding:'4px 8px', borderRadius:'4px', border:'1px solid #1565c0', color:'#1565c0', background:'white', fontSize:'11px', cursor:'pointer'}}>
                    {t('mp.edit')}
                  </button>
                  <button onClick={async () => { if (!window.confirm(t('mp.deleteConfirm'))) return; await axiosClient.delete(`/merchants/products/${p.id}?merchant_id=${selectedMerchantId}`); const res = await axiosClient.get(`/merchants/products?merchant_id=${selectedMerchantId}`); setMyProducts(res.data.products || []); }} style={{padding:'4px 8px', borderRadius:'4px', border:'1px solid #c62828', color:'#c62828', background:'white', fontSize:'11px', cursor:'pointer'}}>{t('mp.delete')}</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (merchantStatus === 'pending') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('merchant.apply')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'60px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>⏳</div>
            <p style={{marginTop:'12px', fontSize:'16px'}}>{t('merchant.pending')}</p>
            <p style={{marginTop:'8px', fontSize:'13px'}}>{t('merchant.applySuccess')}</p>
          </div>
        </div>
      );
    }

    if (merchantStatus === 'rejected') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('merchant.apply')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>❌</div>
            <p style={{marginTop:'12px', fontSize:'16px'}}>{t('merchant.rejected')}</p>
            {rejectReason && (
              <div style={{background:'#ffebee', borderRadius:'12px', padding:'16px', margin:'16px auto', maxWidth:'320px', textAlign:'left'}}>
                <div style={{fontSize:'13px', color:'#c62828', fontWeight:'bold', marginBottom:'8px'}}>拒绝原因：</div>
                <div style={{fontSize:'13px', color:'#333'}}>{rejectReason}</div>
              </div>
            )}
            <button 
              onClick={() => {
                setMerchantStatus(null);
                setRejectReason('');
                setMAgree(false);
                // 清空表单
                setMName(''); setMContact(''); setMPhone(''); setEmail(''); setMDesc('');
                setIdCardFront(''); setIdCardBack(''); setBusinessLicense(''); setLegalIdCard('');
                setMerchantType('personal'); setCountry('CN');
              }}
              style={{marginTop:'16px', padding:'10px 24px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}
            >
              重新申请
            </button>
          </div>
        </div>
      );
    }

    const submitApply = async () => {
      if (!mName || !mContact || !mPhone || !email || !mAgree) {
        alert(t('merchant.fillRequired'));
        return;
      }
      if (merchantType === 'personal' && (!idCardFront || !idCardBack)) {
        alert(t('merchant.uploadIdCard'));
        return;
      }
      if (merchantType === 'enterprise' && (!businessLicense || !legalIdCard)) {
        alert(t('merchant.uploadEnterprise'));
        return;
      }

      try {
        await axiosClient.post('/merchants/apply', {
          merchant_type: merchantType,
          country,
          name: mName,
          contact: mContact,
          phone: mPhone,
          email,
          description: mDesc,
          id_card_front: idCardFront,
          id_card_back: idCardBack,
          business_license: businessLicense,
          legal_id_card: legalIdCard
        });
        setMerchantStatus('pending');
        // 刷新店铺列表
        const res = await axiosClient.get('/merchants/me');
        setMerchants(res.data.merchants || []);
      } catch (e: any) {
        const msg = e.response?.data?.error;
        if (msg === 'Already applied') alert(t('merchant.alreadyApplied'));
        else alert(t('merchant.applyFail'));
      }
    };

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('merchant.apply')}</span>
          <span style={{width:36}}></span>
        </div>
        <div style={{padding:'16px'}}>
          <div style={{textAlign:'center', marginBottom:'20px'}}>
            <div style={{fontSize:48}}>🏪</div>
            <h3 style={{marginTop:'8px', color:'#611f69'}}>{t('merchant.apply')}</h3>
          </div>
          
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
            {/* 商家类型 */}
            <label style={{fontSize:'13px', color:'#666', display:'block', marginBottom:'8px'}}>{t('merchant.typeLabel')}</label>
            <div style={{display:'flex', gap:'10px', marginBottom:'12px'}}>
              <button onClick={() => setMerchantType('personal')} style={{flex:1, padding:'10px', borderRadius:'8px', border: merchantType === 'personal' ? '2px solid #611f69' : '1px solid #ddd', background: merchantType === 'personal' ? '#f8f5ff' : '#fff', color: merchantType === 'personal' ? '#611f69' : '#666', fontSize:'14px', cursor:'pointer'}}>{t('merchant.typePersonal')}</button>
              <button onClick={() => setMerchantType('enterprise')} style={{flex:1, padding:'10px', borderRadius:'8px', border: merchantType === 'enterprise' ? '2px solid #611f69' : '1px solid #ddd', background: merchantType === 'enterprise' ? '#f8f5ff' : '#fff', color: merchantType === 'enterprise' ? '#611f69' : '#666', fontSize:'14px', cursor:'pointer'}}>{t('merchant.typeEnterprise')}</button>
            </div>

            {/* 国家/地区 */}
            <label style={{fontSize:'13px', color:'#666', display:'block', marginBottom:'4px'}}>{t('merchant.countryLabel')}</label>
            <select 
              value={country} 
              onChange={(e) => setCountry(e.target.value)} 
              style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'12px', background:'#fff'}}
            >
              <optgroup label="🇨🇳 中国">
                <option value="CN">🇨🇳 中国大陆</option>
                <option value="HK">🇭🇰 中国香港</option>
                <option value="MO">🇲🇴 中国澳门</option>
                <option value="TW">🇹🇼 中国台湾</option>
              </optgroup>
              <optgroup label="🇺🇸 北美/欧洲/大洋洲">
                <option value="US">🇺🇸 美国</option>
                <option value="GB">🇬🇧 英国</option>
                <option value="DE">🇩🇪 德国</option>
                <option value="FR">🇫🇷 法国</option>
                <option value="AU">🇦🇺 澳大利亚</option>
                <option value="CA">🇨🇦 加拿大</option>
                <option value="JP">🇯🇵 日本</option>
                <option value="KR">🇰🇷 韩国</option>
              </optgroup>
              <optgroup label="🌏 东南亚">
                <option value="SG">🇸🇬 新加坡</option>
                <option value="MY">🇲🇾 马来西亚</option>
                <option value="TH">🇹🇭 泰国</option>
                <option value="VN">🇻🇳 越南</option>
                <option value="ID">🇮🇩 印度尼西亚</option>
                <option value="PH">🇵🇭 菲律宾</option>
                <option value="MM">🇲🇲 缅甸</option>
                <option value="KH">🇰🇭 柬埔寨</option>
                <option value="LA">🇱🇦 老挝</option>
                <option value="BN">🇧🇳 文莱</option>
                <option value="IN">🇮🇳 印度</option>
              </optgroup>
            </select>

            <input value={mName} onChange={(e) => setMName(e.target.value)} placeholder={t('merchant.storeName')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'10px'}} />
            <input value={mContact} onChange={(e) => setMContact(e.target.value)} placeholder={t('merchant.contactName')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'10px'}} />
            <input value={mPhone} onChange={(e) => setMPhone(e.target.value)} placeholder={t('merchant.phone')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'10px'}} />
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('merchant.email')} type="email" style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'10px'}} />
            <textarea value={mDesc} onChange={(e) => setMDesc(e.target.value)} placeholder={t('merchant.desc')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'12px', height:'60px', resize:'none'}} />

            {/* 个人资质 */}
            {merchantType === 'personal' && (
              <div style={{background:'#f8f8f8', borderRadius:'8px', padding:'12px', marginBottom:'12px'}}>
                <div style={{fontSize:'13px', fontWeight:'bold', color:'#333', marginBottom:'8px'}}>{t('merchant.personalQualification')}</div>
                <div style={{marginBottom:'8px'}}>
                  <label style={{fontSize:'12px', color:'#666'}}>{t('merchant.idCardFront')}</label>
                  <input type="file" accept="image/*" onChange={(e) => uploadQualification(e, setIdCardFront)} style={{fontSize:'12px', display:'block', marginTop:'4px'}} />
                  {idCardFront && <img src={idCardFront} alt={t('merchant.idCardFront')} style={{width:'80px', height:'50px', objectFit:'cover', borderRadius:'4px', marginTop:'4px'}} />}
                </div>
                <div>
                  <label style={{fontSize:'12px', color:'#666'}}>{t('merchant.idCardBack')}</label>
                  <input type="file" accept="image/*" onChange={(e) => uploadQualification(e, setIdCardBack)} style={{fontSize:'12px', display:'block', marginTop:'4px'}} />
                  {idCardBack && <img src={idCardBack} alt={t('merchant.idCardBack')} style={{width:'80px', height:'50px', objectFit:'cover', borderRadius:'4px', marginTop:'4px'}} />}
                </div>
              </div>
            )}

            {/* 企业资质 */}
            {merchantType === 'enterprise' && (
              <div style={{background:'#f8f8f8', borderRadius:'8px', padding:'12px', marginBottom:'12px'}}>
                <div style={{fontSize:'13px', fontWeight:'bold', color:'#333', marginBottom:'8px'}}>{t('merchant.enterpriseQualification')}</div>
                <div style={{marginBottom:'8px'}}>
                  <label style={{fontSize:'12px', color:'#666'}}>{t('merchant.businessLicense')}</label>
                  <input type="file" accept="image/*" onChange={(e) => uploadQualification(e, setBusinessLicense)} style={{fontSize:'12px', display:'block', marginTop:'4px'}} />
                  {businessLicense && <img src={businessLicense} alt={t('merchant.businessLicense')} style={{width:'80px', height:'50px', objectFit:'cover', borderRadius:'4px', marginTop:'4px'}} />}
                </div>
                <div>
                  <label style={{fontSize:'12px', color:'#666'}}>{t('merchant.legalIdCard')}</label>
                  <input type="file" accept="image/*" onChange={(e) => uploadQualification(e, setLegalIdCard)} style={{fontSize:'12px', display:'block', marginTop:'4px'}} />
                  {legalIdCard && <img src={legalIdCard} alt={t('merchant.legalIdCard')} style={{width:'80px', height:'50px', objectFit:'cover', borderRadius:'4px', marginTop:'4px'}} />}
                </div>
              </div>
            )}

            <label style={{display:'flex', alignItems:'center', gap:'8px', fontSize:'13px', color:'#666', marginBottom:'16px'}}>
              <input type="checkbox" checked={mAgree} onChange={(e) => setMAgree(e.target.checked)} />
              {t('merchant.agreement')}
            </label>
            <button onClick={submitApply} disabled={!mName || !mContact || !mPhone || !email || !mAgree} style={{width:'100%', padding:'12px', background: (!mName || !mContact || !mPhone || !email || !mAgree) ? '#ccc' : '#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'16px', cursor: (!mName || !mContact || !mPhone || !email || !mAgree) ? 'not-allowed' : 'pointer'}}>{t('merchant.submit')}</button>
          </div>
        </div>
      </div>
    );
  }

     // ==================== 商家店铺装修页面 ====================
  if (subPage === 'merchant-store-edit') {
    if (merchantStatus !== 'approved') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('store.update')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'60px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🔒</div>
            <p>{t('merchant.comingSoon')}</p>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('store.update')}</span>
          <span style={{width:36}}></span>
        </div>
        <div style={{padding:'16px'}}>
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', marginBottom:'16px'}}>
            <h3 style={{marginBottom:'12px', color:'#611f69'}}>🎨 {t('store.update')}</h3>
            <label style={{fontSize:'13px', color:'#666', display:'block', marginBottom:'4px'}}>{t('store.logo')}</label>
            <input value={storeForm.logo} onChange={(e) => setStoreForm({...storeForm, logo: e.target.value})} placeholder="https://..." style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'12px'}} />
            
            <label style={{fontSize:'13px', color:'#666', display:'block', marginBottom:'4px'}}>{t('store.announcement')}</label>
            <textarea value={storeForm.announcement} onChange={(e) => setStoreForm({...storeForm, announcement: e.target.value})} placeholder={t('store.announcement')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'12px', height:'80px', resize:'none'}} />
            
            <label style={{fontSize:'13px', color:'#666', display:'block', marginBottom:'8px'}}>{t('store.businessHours')}</label>
            <div style={{display:'flex', gap:'12px', marginBottom:'16px'}}>
              <label style={{display:'flex', alignItems:'center', gap:'6px', fontSize:'14px', cursor:'pointer'}}>
                <input type="radio" checked={storeForm.business_hours?.open !== false} onChange={() => setStoreForm({...storeForm, business_hours: { open: true }})} />
                🟢 {t('store.open')}
              </label>
              <label style={{display:'flex', alignItems:'center', gap:'6px', fontSize:'14px', cursor:'pointer'}}>
                <input type="radio" checked={storeForm.business_hours?.open === false} onChange={() => setStoreForm({...storeForm, business_hours: { open: false }})} />
                🔴 {t('store.closed')}
              </label>
            </div>
            
            <button onClick={async () => {
              try {
                await axiosClient.patch(`/merchants/me?merchant_id=${selectedMerchantId}`, storeForm);
                alert(t('store.updated'));
              } catch (e) {}
            }} style={{width:'100%', padding:'12px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>{t('store.update')}</button>
          </div>
        </div>
      </div>
    );
  }
 
    
  if (subPage === 'merchant-stats') {
    if (merchantStatus !== 'approved') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('stats.title')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'60px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🔒</div>
            <p>{t('merchant.comingSoon')}</p>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('stats.title')}</span>
          <span style={{width:36}}></span>
        </div>

        {/* 销售概览 */}
        <div style={{padding:'16px'}}>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'16px'}}>
            <div style={{background:'linear-gradient(135deg, #611f69, #9b59b6)', borderRadius:'12px', padding:'16px', color:'white'}}>
              <div style={{fontSize:'12px', opacity:0.8}}>{t('stats.todaySales')}</div>
              <div style={{fontSize:'22px', fontWeight:'bold', marginTop:'4px'}}>π {merchantStats?.todaySales?.toFixed(2) || '0.00'}</div>
            </div>
            <div style={{background:'linear-gradient(135deg, #1565c0, #42a5f5)', borderRadius:'12px', padding:'16px', color:'white'}}>
              <div style={{fontSize:'12px', opacity:0.8}}>{t('stats.weekSales')}</div>
              <div style={{fontSize:'22px', fontWeight:'bold', marginTop:'4px'}}>π {merchantStats?.weekSales?.toFixed(2) || '0.00'}</div>
            </div>
            <div style={{background:'linear-gradient(135deg, #2e7d32, #66bb6a)', borderRadius:'12px', padding:'16px', color:'white'}}>
              <div style={{fontSize:'12px', opacity:0.8}}>{t('stats.monthSales')}</div>
              <div style={{fontSize:'22px', fontWeight:'bold', marginTop:'4px'}}>π {merchantStats?.monthSales?.toFixed(2) || '0.00'}</div>
            </div>
            <div style={{background:'linear-gradient(135deg, #e65100, #ff9800)', borderRadius:'12px', padding:'16px', color:'white'}}>
              <div style={{fontSize:'12px', opacity:0.8}}>{t('stats.totalSales')}</div>
              <div style={{fontSize:'22px', fontWeight:'bold', marginTop:'4px'}}>π {merchantStats?.totalSales?.toFixed(2) || '0.00'}</div>
            </div>
          </div>

          {/* 关键指标 */}
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'8px', marginBottom:'16px'}}>
            <div style={{background:'#fff', borderRadius:'12px', padding:'12px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'20px', fontWeight:'bold', color:'#611f69'}}>{merchantStats?.orderCount || 0}</div>
              <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{t('stats.orderCount')}</div>
            </div>
            <div style={{background:'#fff', borderRadius:'12px', padding:'12px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'20px', fontWeight:'bold', color:'#611f69'}}>{merchantStats?.productCount || 0}</div>
              <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{t('stats.productCount')}</div>
            </div>
            <div style={{background:'#fff', borderRadius:'12px', padding:'12px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'20px', fontWeight:'bold', color:'#ff9800'}}>{merchantStats?.pendingShip || 0}</div>
              <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{t('stats.pendingShip')}</div>
            </div>
            <div style={{background:'#fff', borderRadius:'12px', padding:'12px', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'20px', fontWeight:'bold', color:'#f44336'}}>{merchantStats?.refundPending || 0}</div>
              <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{t('stats.refundPending')}</div>
            </div>
          </div>

          {/* 商品排行 TOP 10 */}
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
            <h3 style={{marginBottom:'12px', color:'#611f69'}}>🏆 {t('stats.productRanking')}</h3>
            {productRanking.length === 0 ? (
              <div style={{textAlign:'center', padding:'20px', color:'#999'}}>{t('stats.noData')}</div>
            ) : productRanking.map((p: any, idx: number) => (
              <div key={p.id} style={{display:'flex', alignItems:'center', gap:'10px', padding:'8px 0', borderBottom: idx < productRanking.length - 1 ? '1px solid #f0f0f0' : 'none'}}>
                <div style={{
                  width:'28px', height:'28px', borderRadius:'50%',
                  background: idx === 0 ? '#FFD700' : idx === 1 ? '#C0C0C0' : idx === 2 ? '#CD7F32' : '#eee',
                  color: idx < 3 ? '#fff' : '#666',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:'13px', fontWeight:'bold', flexShrink:0,
                }}>{idx + 1}</div>
                <img src={p.image} alt="" style={{width:'36px', height:'36px', objectFit:'cover', borderRadius:'6px'}} onError={(e: any) => e.target.style.display='none'} />
                <div style={{flex:1, minWidth:0}}>
                  <div style={{fontSize:'13px', fontWeight:500, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{p.name}</div>
                  <div style={{fontSize:'11px', color:'#999'}}>π{p.piPrice} · {t('stats.sales')}: {p.sales || 0}</div>
                </div>
                <div style={{fontSize:'13px', color:'#611f69', fontWeight:'bold'}}>{p.order_count || 0} {t('stats.orderNum')}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
 
  // ==================== 商家提现页面 ====================
  if (subPage === 'merchant-withdraw') {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('merchant-finance')}>←</span>
          <span className="detail-title">{t('mf.requestWithdrawal')}</span>
          <span style={{width:36}}></span>
        </div>

        {/* 余额显示 */}
        <div style={{padding:'16px'}}>
          <div style={{background:'linear-gradient(135deg, #611f69, #9b59b6)', borderRadius:'12px', padding:'20px', color:'white', marginBottom:'16px'}}>
            <div style={{fontSize:'13px', opacity:0.8}}>{t('mf.availableBalance')}</div>
            <div style={{fontSize:'28px', fontWeight:'bold', marginTop:'6px'}}>π {financeData?.balance?.toFixed(2) || '0.00'}</div>
          </div>

          {/* 提现表单 */}
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
            <label style={{fontSize:'14px', color:'#666', marginBottom:'8px', display:'block'}}>{t('mf.withdrawAmount')}</label>
            <input
              value={withdrawAmount}
              onChange={(e) => setWithdrawAmount(e.target.value)}
              placeholder="0.00"
              type="number"
              step="0.01"
              min="0"
              style={{width:'100%', padding:'12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'18px', outline:'none', boxSizing:'border-box', marginBottom:'12px'}}
            />
            <label style={{fontSize:'14px', color:'#666', marginBottom:'8px', display:'block'}}>{t('mf.piWalletAddress')}</label>
            <input
              value={withdrawWallet}
              onChange={(e) => setWithdrawWallet(e.target.value)}
              placeholder={t('mf.walletPlaceholder')}
              style={{width:'100%', padding:'12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'16px'}}
            />
            <button
              onClick={async () => {
                const amount = parseFloat(withdrawAmount);
                if (!amount || amount <= 0) { alert(t('mf.invalidAmount')); return; }
                if (!withdrawWallet.trim()) { alert(t('mf.walletRequired')); return; }
                try {
                  await axiosClient.post(`/merchants/withdrawals?merchant_id=${selectedMerchantId}`, { amount, piWalletAddress: withdrawWallet.trim() });
                  setWithdrawAmount('');
                  setWithdrawWallet('');
                  alert(t('mf.withdrawSubmitted'));
                  fetchFinance();
                  fetchWithdrawals();
                  setSubPage('merchant-finance');
                } catch (e: any) {
                  const msg = e.response?.data?.error;
                  alert(msg || t('failed'));
                }
              }}
              disabled={!withdrawAmount || !withdrawWallet.trim()}
              style={{width:'100%', padding:'12px', background: (withdrawAmount && withdrawWallet.trim()) ? '#611f69' : '#ccc', color:'white', border:'none', borderRadius:'8px', fontSize:'16px', cursor: (withdrawAmount && withdrawWallet.trim()) ? 'pointer' : 'not-allowed', fontWeight:'bold'}}
            >{t('mf.submitWithdrawal')}</button>
          </div>

          {/* 提现记录 */}
          <h3 style={{marginBottom:'8px', fontSize:'15px'}}>{t('mf.withdrawalHistory')}</h3>
          {withdrawals.length === 0 ? (
            <div style={{textAlign:'center', padding:'30px', color:'#999'}}>
              <div style={{fontSize:36}}>💸</div>
              <p>{t('mf.noWithdrawals')}</p>
            </div>
          ) : withdrawals.map((w: any) => (
            <div key={w.id} style={{background:'#fff', borderRadius:'12px', padding:'14px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <div>
                  <div style={{fontSize:'15px', fontWeight:'bold', color:'#f44336'}}>-π {w.amount?.toFixed(2)}</div>
                  <div style={{fontSize:'11px', color:'#999', marginTop:'4px'}}>{w.created_at ? new Date(w.created_at).toLocaleString() : '-'}</div>
                  <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{t('mf.piWalletAddress')}: {w.pi_wallet_address?.slice(0, 12)}...</div>
                </div>
                <div style={{
                  padding:'4px 10px',
                  borderRadius:'12px',
                  fontSize:'12px',
                  fontWeight:'bold',
                  background: w.status === 'completed' ? '#e8f5e9' : w.status === 'rejected' ? '#ffebee' : '#fff3e0',
                  color: w.status === 'completed' ? '#2e7d32' : w.status === 'rejected' ? '#c62828' : '#e65100',
                }}>
                  {w.status === 'completed' ? '✅ ' + t('mf.completed') : w.status === 'rejected' ? '❌ ' + t('mf.rejected') : '⏳ ' + t('mf.pendingReview')}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

    // ==================== 商家订单管理页面 ====================
  if (subPage === 'merchant-orders') {
    if (merchantStatus !== 'approved') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('merchant.orders')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'60px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🔒</div>
            <p>{t('merchant.comingSoon')}</p>
          </div>
        </div>
      );
    }

    const statusTabs = [
      { key: 'pending', label: '📦 ' + t('mo.pendingShip') },
      { key: 'shipped', label: '🚚 ' + t('mo.shipped') },
      { key: 'completed', label: '✅ ' + t('mo.completed') },
      { key: 'refund', label: '💸 ' + t('mo.refundPending') },
    ];

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('merchant.orders')}</span>
          <span style={{width:36}}></span>
        </div>

        {/* 状态筛选 */}
        <div style={{display:'flex', gap:'6px', padding:'12px 16px', overflowX:'auto', background:'#fff', borderBottom:'1px solid #eee'}}>
          {statusTabs.map(tab => (
            <button
              key={tab.key}
              onClick={() => setOrderFilter(tab.key)}
              style={{
                padding:'6px 14px',
                borderRadius:'20px',
                border: orderFilter === tab.key ? '1px solid #611f69' : '1px solid #ddd',
                background: orderFilter === tab.key ? '#611f69' : '#fff',
                color: orderFilter === tab.key ? '#fff' : '#666',
                fontSize:'12px',
                whiteSpace:'nowrap',
                cursor:'pointer',
              }}
            >{tab.label}</button>
          ))}
        </div>

        {/* 订单列表 */}
        <div style={{padding:'12px'}}>
          {merchantOrders.length === 0 ? (
            <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
              <div style={{fontSize:48}}>📋</div>
              <p>{t('mo.noOrders')}</p>
            </div>
          ) : merchantOrders.map((order: any) => (
            <div key={order.id} style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              {/* 订单头部 */}
              <div style={{display:'flex', justifyContent:'space-between', marginBottom:'8px'}}>
                <span style={{fontWeight:'bold', fontSize:'14px'}}>{order.product_name || t('mine.orderNum') + ' #' + order.id}</span>
                <span style={{fontSize:'12px', color: order.refund_status === 'pending' ? '#ff9800' : order.shipping_status === 'shipped' ? '#2196f3' : order.shipping_status === 'completed' ? '#4caf50' : '#ff9800'}}>
                  {order.refund_status === 'pending' ? t('mo.refundPending') :
                   order.shipping_status === 'shipped' ? t('mo.shipped') :
                   order.shipping_status === 'completed' ? t('mo.completed') :
                   t('mo.pendingShip')}
                </span>
              </div>

              {/* 商品信息 */}
              <div style={{display:'flex', gap:'10px', marginBottom:'10px'}}>
                {order.product_image && (
                  <img src={order.product_image} alt="" style={{width:'50px', height:'50px', objectFit:'cover', borderRadius:'8px'}} onError={(e: any) => e.target.style.display='none'} />
                )}
                <div style={{flex:1}}>
                  <div style={{fontSize:'13px', color:'#333'}}>{order.product_name}</div>
                  <div style={{fontSize:'13px', color:'#611f69', fontWeight:'bold', marginTop:'2px'}}>π {order.piPrice || order.paid}</div>
                  <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>
                    {t('mine.orderNum')} #{order.id} · {order.quantity || 1} {t('mo.items')}
                  </div>
                </div>
              </div>

              {/* 退款原因 */}
              {order.refund_status === 'pending' && order.refund_reason && (
                <div style={{background:'#fff3e0', borderRadius:'8px', padding:'8px 12px', marginBottom:'10px', fontSize:'12px', color:'#e65100'}}>
                  💬 {t('mo.refundReason')}: {order.refund_reason}
                </div>
              )}

              {/* 物流信息 */}
              {order.tracking_number && (
                <div style={{background:'#e3f2fd', borderRadius:'8px', padding:'8px 12px', marginBottom:'10px', fontSize:'12px', color:'#1565c0'}}>
                  🚚 {t('mo.tracking')}: {order.tracking_number}
                </div>
              )}

              {/* 时间信息 */}
              <div style={{fontSize:'11px', color:'#bbb', marginBottom:'10px'}}>
                {t('mo.orderTime')}: {order.created_at ? new Date(order.created_at).toLocaleString() : '-'}
                {order.shipped_at && ` · ${t('mo.shipTime')}: ${new Date(order.shipped_at).toLocaleString()}`}
              </div>

              {/* 操作按钮 */}
              <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
                {/* 待发货 → 填写物流单号发货 */}
                {orderFilter === 'pending' && (
                  shipOrderId === String(order.id) ? (
                    <>
                      <input
                        value={trackingNumber}
                        onChange={(e) => setTrackingNumber(e.target.value)}
                        placeholder={t('mo.enterTracking')}
                        style={{flex:1, padding:'8px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'13px', outline:'none'}}
                      />
                      <button
                        onClick={async () => {
                          if (!trackingNumber.trim()) return;
                          await axiosClient.patch(`/merchants/orders/${order.id}/ship?merchant_id=${selectedMerchantId}`, { trackingNumber: trackingNumber.trim() });
                          setShipOrderId(null);
                          setTrackingNumber('');
                          fetchMerchantOrders();
                        }}
                        style={{padding:'8px 16px', background:'#4caf50', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                      >✅ {t('mo.confirmShip')}</button>
                      <button
                        onClick={() => { setShipOrderId(null); setTrackingNumber(''); }}
                        style={{padding:'8px 12px', background:'#eee', color:'#333', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                      >{t('cancel')}</button>
                    </>
                  ) : (
                    <button
                      onClick={() => { setShipOrderId(String(order.id)); setTrackingNumber(''); }}
                      style={{padding:'8px 16px', background:'#611f69', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                    >📦 {t('mo.ship')}</button>
                  )
                )}

                {/* 已发货 → 确认完成 */}
                {orderFilter === 'shipped' && (
                  <button
                    onClick={async () => {
                      await axiosClient.patch(`/merchants/orders/${order.id}/complete?merchant_id=${selectedMerchantId}`);
                      fetchMerchantOrders();
                    }}
                    style={{padding:'8px 16px', background:'#4caf50', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                  >✅ {t('mo.confirmComplete')}</button>
                )}

                {/* 退款处理 */}
                {orderFilter === 'refund' && (
                  <>
                    <button
                      onClick={async () => {
                        if (!window.confirm(t('mo.approveRefundConfirm'))) return;
                        await axiosClient.patch(`/merchants/orders/${order.id}/refund?merchant_id=${selectedMerchantId}`, { action: 'approved' });
                        fetchMerchantOrders();
                      }}
                      style={{padding:'8px 16px', background:'#4caf50', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                    >✅ {t('mo.approveRefund')}</button>
                    <button
                      onClick={async () => {
                        await axiosClient.patch(`/merchants/orders/${order.id}/refund?merchant_id=${selectedMerchantId}`, { action: 'rejected' });
                        fetchMerchantOrders();
                      }}
                      style={{padding:'8px 16px', background:'#f44336', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer'}}
                    >❌ {t('mo.rejectRefund')}</button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

    // ==================== 商家财务页面 ====================
  if (subPage === 'merchant-finance') {
    if (merchantStatus !== 'approved') {
      return (
        <div>
          <div className="detail-header">
            <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
            <span className="detail-title">{t('finance.title')}</span>
            <span style={{width:36}}></span>
          </div>
          <div style={{textAlign:'center', padding:'60px 20px', color:'#999'}}>
            <div style={{fontSize:48}}>🔒</div>
            <p>{t('merchant.comingSoon')}</p>
          </div>
        </div>
      );
    }

    const tabs = [
      { key: 'overview' as const, label: '📊 ' + t('finance.overview') },
      { key: 'transactions' as const, label: '📋 ' + t('finance.transactions') },
      { key: 'withdrawals' as const, label: '💳 ' + t('finance.withdrawals') },
    ];

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('main')}>←</span>
          <span className="detail-title">{t('finance.title')}</span>
          <span style={{width:36}}></span>
        </div>

        <div style={{display:'flex', gap:'6px', padding:'12px 16px', background:'#fff', borderBottom:'1px solid #eee'}}>
          {tabs.map(tab => (
            <button key={tab.key} onClick={() => setFinanceTab(tab.key)} style={{
              padding:'6px 14px', borderRadius:'20px',
              border: financeTab === tab.key ? '1px solid #611f69' : '1px solid #ddd',
              background: financeTab === tab.key ? '#611f69' : '#fff',
              color: financeTab === tab.key ? '#fff' : '#666',
              fontSize:'12px', whiteSpace:'nowrap', cursor:'pointer',
            }}>{tab.label}</button>
          ))}
        </div>

        {/* 收入概览 */}
        {financeTab === 'overview' && (
          <div style={{padding:'16px'}}>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'16px'}}>
              <div style={{background:'linear-gradient(135deg, #611f69, #9b59b6)', borderRadius:'12px', padding:'16px', color:'white'}}>
                <div style={{fontSize:'12px', opacity:0.8}}>{t('finance.totalEarnings')}</div>
                <div style={{fontSize:'24px', fontWeight:'bold', marginTop:'4px'}}>π {financeData?.totalEarnings?.toFixed(2) || '0.00'}</div>
              </div>
              <div style={{background:'linear-gradient(135deg, #1565c0, #42a5f5)', borderRadius:'12px', padding:'16px', color:'white'}}>
                <div style={{fontSize:'12px', opacity:0.8}}>{t('finance.balance')}</div>
                <div style={{fontSize:'24px', fontWeight:'bold', marginTop:'4px'}}>π {financeData?.balance?.toFixed(2) || '0.00'}</div>
              </div>
              <div style={{background:'#fff', borderRadius:'12px', padding:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <div style={{fontSize:'12px', color:'#999'}}>{t('finance.totalWithdrawn')}</div>
                <div style={{fontSize:'20px', fontWeight:'bold', marginTop:'4px', color:'#4caf50'}}>π {financeData?.totalWithdrawn?.toFixed(2) || '0.00'}</div>
              </div>
              <div style={{background:'#fff', borderRadius:'12px', padding:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <div style={{fontSize:'12px', color:'#999'}}>{t('finance.pendingWithdrawals')}</div>
                <div style={{fontSize:'20px', fontWeight:'bold', marginTop:'4px', color:'#ff9800'}}>π {financeData?.pendingWithdrawals?.toFixed(2) || '0.00'}</div>
              </div>
            </div>

            {/* 提现表单 */}
            <div style={{background:'#fff', borderRadius:'12px', padding:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
              <h3 style={{marginBottom:'12px', color:'#611f69'}}>💳 {t('finance.withdraw')}</h3>
              <input value={withdrawAmount} onChange={(e) => setWithdrawAmount(e.target.value)} placeholder={t('finance.withdrawAmount')} type="number" step="0.01" style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
              <input value={piWalletAddress} onChange={(e) => setPiWalletAddress(e.target.value)} placeholder={t('finance.piWallet')} style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', marginBottom:'8px'}} />
              <button onClick={async () => {
                if (!withdrawAmount || !piWalletAddress) return;
                try {
                  await axiosClient.post(`/merchants/withdrawals?merchant_id=${selectedMerchantId}`, { amount: parseFloat(withdrawAmount), piWalletAddress });
                  setWithdrawAmount('');
                  setPiWalletAddress('');
                  alert(t('finance.withdrawSuccess'));
                  fetchFinance();
                  fetchWithdrawals();
                } catch (e: any) {
                  const msg = e.response?.data?.error;
                  if (msg?.includes('Insufficient')) alert(t('finance.insufficientBalance'));
                  else alert(t('finance.withdrawFail'));
                }
              }} style={{width:'100%', padding:'12px', background:'#611f69', color:'white', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}>{t('finance.withdrawSubmit')}</button>
            </div>
          </div>
        )}

        {/* 交易明细 */}
        {financeTab === 'transactions' && (
          <div style={{padding:'12px'}}>
            {transactions.length === 0 ? (
              <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
                <div style={{fontSize:48}}>📋</div>
                <p>{t('finance.noTransactions')}</p>
              </div>
            ) : transactions.map((tx: any) => (
              <div key={tx.id} style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:'6px'}}>
                  <span style={{fontSize:'13px', color:'#611f69', fontWeight:'bold'}}>{tx.type === 'settlement' ? '📊 ' + t('finance.settlement') : '💳 ' + t('finance.withdrawal')}</span>
                  <span style={{fontSize:'14px', fontWeight:'bold', color: tx.type === 'settlement' ? '#4caf50' : '#f44336'}}>
                    {tx.type === 'settlement' ? '+' : '-'}π {tx.amount?.toFixed(2) || '0.00'}
                  </span>
                </div>
                {tx.type === 'settlement' && (
                  <div style={{fontSize:'12px', color:'#999'}}>
                    {t('finance.commission')}: π{tx.commission?.toFixed(2)} · {t('finance.netAmount')}: π{tx.net_amount?.toFixed(2)}
                  </div>
                )}
                <div style={{display:'flex', justifyContent:'space-between', fontSize:'11px', color:'#bbb', marginTop:'4px'}}>
                  <span>{t('finance.status')}: {tx.status === 'completed' ? '✅ ' + t('finance.completedStatus') : tx.status === 'rejected' ? '❌ ' + t('finance.rejectedStatus') : '⏳ ' + t('finance.pendingStatus')}</span>
                  <span>{tx.created_at ? new Date(tx.created_at).toLocaleString() : ''}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 提现记录 */}
        {financeTab === 'withdrawals' && (
          <div style={{padding:'12px'}}>
            {withdrawals.length === 0 ? (
              <div style={{textAlign:'center', padding:'40px 20px', color:'#999'}}>
                <div style={{fontSize:48}}>💳</div>
                <p>{t('finance.noWithdrawals')}</p>
              </div>
            ) : withdrawals.map((w: any) => (
              <div key={w.id} style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:'6px'}}>
                  <span style={{fontSize:'14px', fontWeight:'bold'}}>π {w.amount?.toFixed(2)}</span>
                  <span style={{fontSize:'12px', color: w.status === 'completed' ? '#4caf50' : w.status === 'rejected' ? '#f44336' : '#ff9800'}}>
                    {w.status === 'completed' ? '✅ ' + t('finance.completedStatus') : w.status === 'rejected' ? '❌ ' + t('finance.rejectedStatus') : '⏳ ' + t('finance.pendingStatus')}
                  </span>
                </div>
                <div style={{fontSize:'12px', color:'#999'}}>{t('finance.piWallet')}: {w.pi_wallet_address}</div>
                <div style={{fontSize:'11px', color:'#bbb', marginTop:'4px'}}>{w.created_at ? new Date(w.created_at).toLocaleString() : ''}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==================== 买家订单详情页面 ====================
  if (subPage === 'order-detail' && selectedOrder) {
    const order = selectedOrder;
    const orderStatusSteps = [
      { label: t('bo.stepPaid'), done: !!order.paid, icon: '💰' },
      { label: t('bo.stepShipped'), done: order.shipping_status === 'shipped' || order.shipping_status === 'completed', icon: '📦' },
      { label: t('bo.stepCompleted'), done: order.shipping_status === 'completed', icon: '✅' },
    ];

    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('orders')}>←</span>
          <span className="detail-title">{t('bo.orderDetail')}</span>
          <span style={{width:36}}></span>
        </div>

        {/* 订单状态进度条 */}
        <div style={{background:'#fff', padding:'20px 16px', margin:'12px', borderRadius:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            {orderStatusSteps.map((step, idx) => (
              <React.Fragment key={idx}>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', flex:'0 0 auto'}}>
                  <div style={{
                    width:36, height:36, borderRadius:'50%',
                    background: step.done ? '#611f69' : '#eee',
                    color: step.done ? '#fff' : '#999',
                    display:'flex', alignItems:'center', justifyContent:'center',
                    fontSize:'16px', fontWeight:'bold',
                  }}>{step.icon}</div>
                  <span style={{fontSize:'11px', color: step.done ? '#611f69' : '#999', marginTop:'6px', textAlign:'center'}}>{step.label}</span>
                </div>
                {idx < orderStatusSteps.length - 1 && (
                  <div style={{
                    flex:1, height:2, margin:'0 8px',
                    background: orderStatusSteps[idx + 1].done ? '#611f69' : '#eee',
                    marginTop:'-16px',
                  }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* 退款状态提示 */}
        {order.refund_status === 'pending' && (
          <div style={{background:'#fff3e0', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px'}}>
            <div style={{fontSize:'14px', fontWeight:'bold', color:'#e65100'}}>💸 {t('bo.refundProcessing')}</div>
            {order.refund_reason && <div style={{fontSize:'12px', color:'#bf360c', marginTop:'4px'}}>{t('mo.refundReason')}: {order.refund_reason}</div>}
          </div>
        )}
        {order.refund_status === 'approved' && (
          <div style={{background:'#e8f5e9', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px'}}>
            <div style={{fontSize:'14px', fontWeight:'bold', color:'#2e7d32'}}>✅ {t('bo.refundApproved')}</div>
          </div>
        )}
        {order.refund_status === 'rejected' && (
          <div style={{background:'#ffebee', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px'}}>
            <div style={{fontSize:'14px', fontWeight:'bold', color:'#c62828'}}>❌ {t('bo.refundRejected')}</div>
          </div>
        )}

        {/* 商品信息 */}
        <div style={{background:'#fff', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize:'13px', color:'#999', marginBottom:'8px'}}>{t('bo.productInfo')}</div>
          <div style={{display:'flex', gap:'12px', alignItems:'center'}}>
            {order.product_image && (
              <img src={order.product_image} alt="" style={{width:'60px', height:'60px', objectFit:'cover', borderRadius:'8px'}} onError={(e: any) => e.target.style.display='none'} />
            )}
            <div style={{flex:1}}>
              <div style={{fontSize:'15px', fontWeight:'bold'}}>{getProductName(order.product_id)}</div>
              <div style={{fontSize:'14px', color:'#611f69', fontWeight:'bold', marginTop:'4px'}}>π {getProductPrice(order.product_id)}</div>
              <div style={{fontSize:'12px', color:'#999', marginTop:'2px'}}>{t('mo.items')}: {order.quantity || 1}</div>
            </div>
          </div>
        </div>

        {/* 物流信息 */}
        {order.tracking_number && (
          <div style={{background:'#e3f2fd', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px'}}>
            <div style={{fontSize:'13px', color:'#999', marginBottom:'6px'}}>🚚 {t('bo.shippingInfo')}</div>
            <div style={{fontSize:'14px', color:'#1565c0', fontWeight:'bold'}}>{t('mo.tracking')}: {order.tracking_number}</div>
            {order.shipped_at && <div style={{fontSize:'12px', color:'#666', marginTop:'4px'}}>{t('mo.shipTime')}: {new Date(order.shipped_at).toLocaleString()}</div>}
          </div>
        )}

        {/* 订单信息 */}
        <div style={{background:'#fff', margin:'0 12px', borderRadius:'12px', padding:'16px', marginBottom:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize:'13px', color:'#999', marginBottom:'8px'}}>{t('bo.orderInfo')}</div>
          <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'6px'}}>
            <span style={{color:'#666'}}>{t('mine.orderNum')}</span>
            <span>#{order.id}</span>
          </div>
          <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'6px'}}>
            <span style={{color:'#666'}}>{t('mo.orderTime')}</span>
            <span>{order.created_at ? new Date(order.created_at).toLocaleString() : '-'}</span>
          </div>
          <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'6px'}}>
            <span style={{color:'#666'}}>{t('mine.payment')}</span>
            <span>π {getProductPrice(order.product_id)}</span>
          </div>
          {order.shipped_at && (
            <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'6px'}}>
              <span style={{color:'#666'}}>{t('mo.shipTime')}</span>
              <span>{new Date(order.shipped_at).toLocaleString()}</span>
            </div>
          )}
          {order.completed_at && (
            <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px'}}>
              <span style={{color:'#666'}}>{t('bo.completeTime')}</span>
              <span>{new Date(order.completed_at).toLocaleString()}</span>
            </div>
          )}
        </div>

        {/* 支付方式选择 */}
        <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
          <div style={{fontSize:'14px', fontWeight:600, color:'#333', marginBottom:'12px'}}>选择支付方式</div>
          
          {/* PCM 余额支付 */}
          <div 
            onClick={() => walletInfo?.bound ? setPayMethod('pcm') : alert('请先合并账户并激活钱包')}
            style={{
              display:'flex',
              alignItems:'center',
              padding:'12px',
              border:'2px solid',
              borderColor: payMethod === 'pcm' ? '#611f69' : '#eee',
              borderRadius:'8px',
              marginBottom:'8px',
              cursor: walletInfo?.bound ? 'pointer' : 'not-allowed',
              opacity: walletInfo?.bound ? 1 : 0.6,
              background: payMethod === 'pcm' ? '#f3e5f5' : '#fff'
            }}
          >
            <span style={{fontSize:'24px', marginRight:'12px'}}>💰</span>
            <div style={{flex:1}}>
              <div style={{fontSize:'14px', color:'#333'}}>PCM 钱包余额</div>
              <div style={{fontSize:'12px', color:'#666'}}>
                {walletInfo?.bound 
                  ? `可用 π${walletInfo.balances.find((b: any) => b.currency === 'PI')?.balance?.toFixed(2) || '0.00'}`
                  : '未激活（需合并账户）'
                }
              </div>
            </div>
            {payMethod === 'pcm' && <span style={{color:'#611f69', fontSize:'20px'}}>✓</span>}
          </div>
          
          {/* Pi 钱包直付 */}
          <div 
            onClick={() => setPayMethod('pi')}
            style={{
              display:'flex',
              alignItems:'center',
              padding:'12px',
              border:'2px solid',
              borderColor: payMethod === 'pi' ? '#611f69' : '#eee',
              borderRadius:'8px',
              cursor:'pointer',
              background: payMethod === 'pi' ? '#f3e5f5' : '#fff'
            }}
          >
            <span style={{fontSize:'24px', marginRight:'12px'}}>π</span>
            <div style={{flex:1}}>
              <div style={{fontSize:'14px', color:'#333'}}>Pi 浏览器直接支付</div>
              <div style={{fontSize:'12px', color:'#666'}}>使用 Pi Wallet 应用支付</div>
            </div>
            {payMethod === 'pi' && <span style={{color:'#611f69', fontSize:'20px'}}>✓</span>}
          </div>
        </div>

        {/* 申请退款按钮 */}
        {order.paid && !order.cancelled && !order.refunded && order.refund_status !== 'pending' && order.refund_status !== 'approved' && (
          <div style={{padding:'0 12px', marginBottom:'12px'}}>
            <button
              onClick={() => setSubPage('refund-request')}
              style={{width:'100%', padding:'12px', background:'#ff9800', color:'#fff', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer'}}
            >💸 {t('bo.requestRefund')}</button>
          </div>
        )}
      </div>
    );
  }

  // ==================== 申请退款页面 ====================
    if (subPage === 'refund-request' && selectedOrder) {
    return (
      <div>
        <div className="detail-header">
          <span className="detail-back" onClick={() => setSubPage('order-detail')}>←</span>
          <span className="detail-title">{t('bo.requestRefund')}</span>
          <span style={{width:36}}></span>
        </div>
        <div style={{padding:'16px'}}>
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'12px'}}>
            <div style={{fontSize:'14px', fontWeight:'bold', marginBottom:'8px'}}>{getProductName(selectedOrder.product_id)}</div>
            <div style={{fontSize:'14px', color:'#611f69', fontWeight:'bold'}}>π {getProductPrice(selectedOrder.product_id)}</div>
          </div>
          <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
            <label style={{fontSize:'14px', color:'#666', marginBottom:'8px', display:'block'}}>{t('bo.refundReason')}</label>
            <textarea
              value={refundReason}
              onChange={(e) => setRefundReason(e.target.value)}
              placeholder={t('bo.refundReasonPlaceholder')}
              style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', outline:'none', boxSizing:'border-box', height:'100px', resize:'none'}}
            />
            <button
              onClick={async () => {
                if (!refundReason.trim()) return;
                try {
                  await axiosClient.post(`/orders/${selectedOrder.id}/refund-request`, { reason: refundReason.trim() });
                  setSelectedOrder({...selectedOrder, refund_status: 'pending', refund_reason: refundReason.trim()});
                  setRefundReason('');
                  setSubPage('order-detail');
                } catch (e: any) {
                  const msg = e.response?.data?.error;
                  if (msg === 'Refund already requested') alert(t('bo.refundAlreadyRequested'));
                  else alert(t('failed'));
                }
              }}
              disabled={!refundReason.trim()}
              style={{width:'100%', padding:'12px', marginTop:'12px', background: refundReason.trim() ? '#ff9800' : '#ccc', color:'#fff', border:'none', borderRadius:'8px', fontSize:'16px', cursor: refundReason.trim() ? 'pointer' : 'not-allowed'}}
            >{t('bo.submitRefund')}</button>
          </div>
        </div>
      </div>
    );
  }

    // ==================== 钱包中心页面 ====================
    if (subPage === 'wallet') {
      return (
        <div style={{width:'100%', minHeight:'100vh', background:'#f5f5f5'}}>
          {/* 顶部栏 */}
          <div style={{display:'flex', alignItems:'center', padding:'12px 16px', background:'#fff', borderBottom:'1px solid #eee'}}>
            <button style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}} onClick={() => setSubPage('main')}>←</button>
            <h3 style={{margin:'0 auto', fontSize:'16px', color:'#611f69'}}>💰 PCM 钱包</h3>
            <div style={{width:'40px'}} />
          </div>

          {walletLoading || walletStatus === null ? (
            <div style={{textAlign:'center', padding:'60px 20px'}}>
              <div style={{fontSize:'32px', marginBottom:'12px'}}>⏳</div>
              <div style={{fontSize:'14px', color:'#666', marginBottom:'16px'}}>
                正在检查钱包状态...
              </div>
              {/* 如果加载超过3秒，显示手动刷新按钮 */}
              <button 
                onClick={fetchWalletStatus}
                style={{padding:'8px 16px', background:'#611f69', color:'#fff', border:'none', borderRadius:'6px', cursor:'pointer'}}
              >
                刷新状态
              </button>
            </div>
          ) : !walletStatus.bound ? (
            /* 未合并：引导页面 */
            <div style={{padding:'20px 16px'}}>
              <div style={{background:'#fff', borderRadius:'12px', padding:'20px', textAlign:'center', marginBottom:'16px'}}>
                <div style={{fontSize:'48px', marginBottom:'12px'}}>🔒</div>
                <h3 style={{margin:'0 0 8px', color:'#333'}}>欢迎使用 PCM 钱包</h3>
                <p style={{fontSize:'13px', color:'#666', lineHeight:'1.6', marginBottom:'16px'}}>
                  合并账户后，您可以在所有应用中使用统一的余额支付<br/>
                  积分也会一并合并到钱包中
                </p>
              </div>

              <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
                <div style={{fontSize:'13px', fontWeight:600, color:'#333', marginBottom:'12px'}}>绑定邮箱，激活钱包</div>
              
                <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                  <input
                    type="email"
                    placeholder="请输入邮箱地址"
                    value={bindEmail}
                    onChange={e => setBindEmail(e.target.value)}
                    style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box'}}
                  />
                  <button
                    onClick={handleSendCode}
                    disabled={sendingCode || countdown > 0}
                    style={{
                      padding:'10px 16px',
                      background: countdown > 0 ? '#ccc' : '#611f69',
                      color:'#fff',
                      border:'none',
                      borderRadius:'8px',
                      cursor: countdown > 0 ? 'not-allowed' : 'pointer',
                      fontSize:'13px',
                      whiteSpace:'nowrap'
                    }}
                  >
                    {countdown > 0 ? `${countdown}秒后重发` : (sendingCode ? '发送中...' : '获取验证码')}
                  </button>
                </div>
                
                <input
                  placeholder="6位验证码"
                  value={verifyCode}
                  onChange={e => setVerifyCode(e.target.value)}
                  maxLength={6}
                  style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'8px', boxSizing:'border-box'}}
                />
                
                <input
                  type="password"
                  placeholder="设置6位支付密码"
                  value={bindPin}
                  onChange={e => setBindPin(e.target.value)}
                  maxLength={6}
                  style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'12px', boxSizing:'border-box'}}
                />
                
                <button
                  onClick={handleBindWallet}
                  disabled={walletLoading}
                  style={{
                    width:'100%',
                    padding:'12px',
                    background: walletLoading ? '#ccc' : '#611f69',
                    color:'#fff',
                    border:'none',
                    borderRadius:'8px',
                    fontSize:'15px',
                    cursor: walletLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {walletLoading ? '处理中...' : '立即合并账户'}
                </button>
              </div>

              <div style={{padding:'12px', background:'#fff3e0', borderRadius:'8px', fontSize:'12px', color:'#e65100', lineHeight:'1.6'}}>
                <b>未合并账户限制：</b><br/>
                • 无法使用余额支付<br/>
                • 无法提现到 Pi 钱包<br/>
                • 积分无法映射到区块链
              </div>
            </div>
          ) : (
            /* 已合并：钱包首页 */
            <div style={{padding:'16px'}}>
              {/* 余额卡片 */}
              <div style={{background:'linear-gradient(135deg, #611f69 0%, #8e24aa 100%)', borderRadius:'12px', padding:'20px', color:'#fff', marginBottom:'16px'}}>
                <div style={{fontSize:'13px', opacity:0.9, marginBottom:'4px'}}>可用余额</div>
                {/* 余额显示 */}
                <div style={{fontSize:'28px', fontWeight:'bold', marginBottom:'12px'}}>
                  π {
                    (() => {
                      const piBalance = walletBalances.find((b: any) => b.currency === 'PI')?.balance;
                      return piBalance !== undefined ? Number(piBalance).toFixed(2) : '0.00';
                    })()
                  }
                </div>
                <div style={{display:'flex', gap:'8px'}}>
                  {walletBalances.filter((b: any) => b.currency !== 'PI').map((b: any) => (
                    <span key={b.currency} style={{fontSize:'12px', background:'rgba(255,255,255,0.2)', padding:'4px 8px', borderRadius:'4px'}}>
                      {b.currency}: {b.balance}
                    </span>
                  ))}
                </div>
              </div>
              {/* 调试按钮：如果余额为 0 但已合并，显示刷新 */}
              {walletBalances.length === 0 && (
                <button 
                  onClick={fetchWalletBalance}
                  style={{padding:'8px 16px', background:'#ff9800', color:'#fff', border:'none', borderRadius:'6px', marginBottom:'12px'}}
                >
                  🔄 刷新余额
                </button>
              )}

                    {/* 快捷操作 */}
              <div style={{display:'flex', gap:'12px', marginBottom:'16px'}}>
                <button 
                  onClick={() => setWalletSubPage('recharge')}
                  style={{flex:1, padding:'12px', background:'#fff', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer', boxShadow:'0 1px 3px rgba(0,0,0,0.1)'}}
                >
                  ⬆️ 充值
                </button>
                <button 
                  onClick={() => setWalletSubPage('withdraw')}
                  style={{flex:1, padding:'12px', background:'#fff', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer', boxShadow:'0 1px 3px rgba(0,0,0,0.1)'}}
                >
                  ⬇️ 提现
                </button>
                <button 
                  onClick={() => setWalletSubPage('transfer')}
                  style={{flex:1, padding:'12px', background:'#fff', border:'none', borderRadius:'8px', fontSize:'14px', cursor:'pointer', boxShadow:'0 1px 3px rgba(0,0,0,0.1)'}}
                >
                  ↗️ 转账
                </button>
              </div>

              {/* 重置支付密码 */}
              {(walletSubPage as any) === 'reset-pin' && (
                <div style={{padding:'16px'}}>
                  <div style={{display:'flex', alignItems:'center', marginBottom:'16px'}}>
                    <button style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}} onClick={() => setWalletSubPage('main')}>←</button>
                    <h3 style={{margin:'0 auto', fontSize:'16px'}}>重置支付密码</h3>
                    <div style={{width:'40px'}} />
                  </div>
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                    <div style={{fontSize:'12px', color:'#666', marginBottom:'12px', padding:'8px', background:'#f3e5f5', borderRadius:'6px'}}>
                      ℹ️ 输入您绑定的邮箱，通过验证码重置支付密码
                    </div>
                    <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                      <input
                        type="email"
                        placeholder="请输入绑定的邮箱"
                        value={resetEmail}
                        onChange={e => setResetEmail(e.target.value)}
                        style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box'}}
                      />
                      <button
                        onClick={handleSendCode}
                        disabled={sendingResetCode || resetCountdown > 0}
                        style={{
                          padding:'10px 16px',
                          background: resetCountdown > 0 ? '#ccc' : '#611f69',
                          color:'#fff', border:'none', borderRadius:'8px',
                          cursor: resetCountdown > 0 ? 'not-allowed' : 'pointer',
                          fontSize:'13px', whiteSpace:'nowrap'
                        }}
                      >
                        {resetCountdown > 0 ? `${resetCountdown}秒后重发` : (sendingResetCode ? '发送中...' : '获取验证码')}
                      </button>
                    </div>
                    <input
                      placeholder="6位验证码"
                      value={resetCode}
                      onChange={e => setResetCode(e.target.value)}
                      maxLength={6}
                      style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'8px', boxSizing:'border-box'}}
                    />
                    <input
                      type="password"
                      placeholder="设置新的6位支付密码"
                      value={resetNewPin}
                      onChange={e => setResetNewPin(e.target.value)}
                      maxLength={6}
                      style={{width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'12px', boxSizing:'border-box'}}
                    />
                    <button
                      onClick={handleResetPinCode}
                      disabled={!resetEmail || !resetCode || !resetNewPin}
                      style={{
                        width:'100%', padding:'12px',
                        background: (resetEmail && resetCode && resetNewPin) ? '#611f69' : '#ccc',
                        color:'#fff', border:'none', borderRadius:'8px',
                        fontSize:'15px', cursor: (resetEmail && resetCode && resetNewPin) ? 'pointer' : 'not-allowed'
                      }}
                    >
                      确认重置
                    </button>
                  </div>
                </div>
              )}

                      {/* 子页面：转账 */}
              {walletSubPage === 'transfer' && (
                <div style={{padding:'16px'}}>
                  <div style={{display:'flex', alignItems:'center', marginBottom:'16px'}}>
                    <button style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}} onClick={() => setWalletSubPage('main')}>←</button>
                    <h3 style={{margin:'0 auto', fontSize:'16px'}}>转账</h3>
                    <div style={{width:'40px'}} />
                  </div>
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                    <input 
                      placeholder="对方用户UID" 
                      value={transferTo} 
                      onChange={e => setTransferTo(e.target.value)}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'8px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <input 
                      placeholder="转账金额 (π)" 
                      type="number"
                      value={transferAmount} 
                      onChange={e => setTransferAmount(e.target.value)}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'8px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <input 
                      type="password"
                      placeholder="支付密码（6位数字）" 
                      value={transferPin} 
                      onChange={e => setTransferPin(e.target.value)}
                      maxLength={6}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'8px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <div style={{textAlign:'right', marginBottom:'12px'}}>
                      <span 
                        onClick={() => setWalletSubPage('reset-pin')}
                        style={{fontSize:'12px', color:'#611f69', cursor:'pointer', textDecoration:'underline'}}
                      >忘记密码？</span>
                    </div>
                    <input 
                      placeholder="备注（可选）" 
                      value={transferRemark} 
                      onChange={e => setTransferRemark(e.target.value)}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'12px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <button 
                      onClick={handleTransfer}
                      style={{width:'100%', padding:'12px', background:'#611f69', color:'#fff', border:'none', borderRadius:'8px', fontSize:'15px', cursor:'pointer'}}
                    >
                      确认转账
                    </button>
                  </div>
                </div>
              )}

              {/* 子页面：提现 */}
              {walletSubPage === 'withdraw' && (
                <div style={{padding:'16px'}}>
                  <div style={{display:'flex', alignItems:'center', marginBottom:'16px'}}>
                    <button style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}} onClick={() => setWalletSubPage('main')}>←</button>
                    <h3 style={{margin:'0 auto', fontSize:'16px'}}>提现</h3>
                    <div style={{width:'40px'}} />
                  </div>
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                    <div style={{fontSize:'12px', color:'#666', marginBottom:'12px', padding:'8px', background:'#fff3e0', borderRadius:'6px'}}>
                      ⚠️ 提现需要管理员审核，审核通过后将打款到您的Pi钱包
                    </div>
                    <input 
                      placeholder="Pi 钱包地址" 
                      value={withdrawAddress} 
                      onChange={e => setWithdrawAddress(e.target.value)}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'8px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <input 
                      placeholder="提现金额 (π)" 
                      type="number"
                      value={withdrawAmount} 
                      onChange={e => setWithdrawAmount(e.target.value)}
                      style={{width:'100%', padding:'10px', border:'1px solid #ddd', borderRadius:'8px', marginBottom:'12px', fontSize:'14px', boxSizing:'border-box'}}
                    />
                    <button 
                      onClick={handleWithdrawApply}
                      style={{width:'100%', padding:'12px', background:'#611f69', color:'#fff', border:'none', borderRadius:'8px', fontSize:'15px', cursor:'pointer'}}
                    >
                      提交提现申请
                    </button>
                  </div>
                </div>
              )}

              {/* 子页面：充值 */}
              {walletSubPage === 'recharge' && (
                <div style={{padding:'16px'}}>
                  <div style={{display:'flex', alignItems:'center', marginBottom:'16px'}}>
                    <button style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}} onClick={() => setWalletSubPage('main')}>←</button>
                    <h3 style={{margin:'0 auto', fontSize:'16px'}}>充值</h3>
                    <div style={{width:'40px'}} />
                  </div>

                  {/* 用户 UID 卡片 —— 方便商户/管理员充值 */}
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px', textAlign:'center'}}>
                    <div style={{fontSize:'13px', color:'#999', marginBottom:'8px'}}>您的充值账号（UID）</div>
                    <div style={{fontSize:'20px', fontWeight:'bold', color:'#611f69', marginBottom:'12px', letterSpacing:'1px'}}>
                      {user?.uid || '未获取'}
                    </div>
                    <button
                      onClick={() => {
                        if (user?.uid) {
                          navigator.clipboard?.writeText(user.uid);
                          alert('UID 已复制到剪贴板');
                        }
                      }}
                      style={{padding:'8px 20px', background:'#611f69', color:'#fff', border:'none', borderRadius:'6px', fontSize:'13px', cursor:'pointer'}}
                    >
                      📋 复制 UID
                    </button>
                    <div style={{fontSize:'11px', color:'#999', marginTop:'8px'}}>将 UID 发给商户或管理员，即可完成充值</div>
                  </div>

                  {/* 充值方式说明 */}
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
                    <div style={{fontSize:'14px', fontWeight:600, color:'#333', marginBottom:'12px'}}>充值方式</div>
                    <div style={{display:'flex', alignItems:'flex-start', marginBottom:'10px'}}>
                      <span style={{fontSize:'18px', marginRight:'10px'}}>🏪</span>
                      <div>
                        <div style={{fontSize:'13px', color:'#333', fontWeight:500}}>商户线下充值</div>
                        <div style={{fontSize:'12px', color:'#999'}}>联系商户，提供您的 UID，商户为您充值</div>
                      </div>
                    </div>
                    <div style={{display:'flex', alignItems:'flex-start', marginBottom:'10px'}}>
                      <span style={{fontSize:'18px', marginRight:'10px'}}>👨‍💼</span>
                      <div>
                        <div style={{fontSize:'13px', color:'#333', fontWeight:500}}>平台管理员充值</div>
                        <div style={{fontSize:'12px', color:'#999'}}>联系平台客服，提供您的 UID 进行充值</div>
                      </div>
                    </div>
                    <div style={{display:'flex', alignItems:'flex-start'}}>
                      <span style={{fontSize:'18px', marginRight:'10px'}}>🎁</span>
                      <div>
                        <div style={{fontSize:'13px', color:'#333', fontWeight:500}}>活动奖励</div>
                        <div style={{fontSize:'12px', color:'#999'}}>参与平台活动，自动获得奖励充值</div>
                      </div>
                    </div>
                  </div>

                  {/* 充值记录 */}
                  <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                    <div style={{fontSize:'14px', fontWeight:600, color:'#333', marginBottom:'12px'}}>充值记录</div>
                    {walletTxs.filter((tx: any) => tx.type === 'recharge').length === 0 ? (
                      <div style={{textAlign:'center', color:'#999', padding:'20px', fontSize:'13px'}}>暂无充值记录</div>
                    ) : (
                      walletTxs.filter((tx: any) => tx.type === 'recharge').map((tx: any) => (
                        <div key={tx.id} style={{display:'flex', justifyContent:'space-between', padding:'10px 0', borderBottom:'1px solid #f0f0f0'}}>
                          <div>
                            <div style={{fontSize:'13px', color:'#333'}}>{tx.remark || '充值'}</div>
                            <div style={{fontSize:'11px', color:'#999'}}>{new Date(tx.created_at).toLocaleString()}</div>
                          </div>
                          <div style={{fontSize:'14px', fontWeight:600, color:'#4caf50'}}>
                            +{tx.amount} {tx.currency}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}

              {/* 用 Pi 币充值 */}
              <div style={{background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'16px', border:'2px solid #611f69'}}>
                <div style={{fontSize:'14px', fontWeight:600, color:'#611f69', marginBottom:'12px'}}>
                  💎 用 Pi 币充值
                </div>
                <div style={{display:'flex', gap:'8px', marginBottom:'12px'}}>
                  {[10, 50, 100, 500].map(amt => (
                    <button
                      key={amt}
                      onClick={() => { setRechargeAmount(amt); setCustomAmount(''); }}
                      style={{
                        flex:1, padding:'10px', border: rechargeAmount === amt ? '2px solid #611f69' : '1px solid #ddd',
                        borderRadius:'8px', background: rechargeAmount === amt ? '#f3e5f5' : '#fff',
                        fontSize:'14px', fontWeight: rechargeAmount === amt ? 'bold' : 'normal',
                        color:'#333', cursor:'pointer'
                      }}
                    >
                      π {amt}
                    </button>
                  ))}
                </div>
                <div style={{display:'flex', gap:'8px', alignItems:'center', marginBottom:'12px'}}>
                  <span style={{fontSize:'13px', color:'#666'}}>自定义：</span>
                  <input
                    type="number"
                    value={customAmount}
                    onChange={e => { setCustomAmount(e.target.value); setRechargeAmount(0); }}
                    placeholder="输入金额"
                    style={{flex:1, padding:'10px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box'}}
                  />
                </div>
                <button
                  onClick={handlePiRecharge}
                  disabled={(!rechargeAmount && !customAmount) || piRecharging}
                  style={{
                    width:'100%', padding:'12px',
                    background: (rechargeAmount || customAmount) ? '#611f69' : '#ccc',
                    color:'#fff', border:'none', borderRadius:'8px',
                    fontSize:'15px', cursor: (rechargeAmount || customAmount) ? 'pointer' : 'not-allowed'
                  }}
                >
                  {piRecharging ? '处理中...' : '💎 用 Pi 支付充值'}
                </button>
              </div>

              {/* 交易记录 */}
              <div style={{background:'#fff', borderRadius:'12px', padding:'16px'}}>
                <div style={{fontSize:'14px', fontWeight:600, color:'#333', marginBottom:'12px'}}>交易记录</div>
                
                {/* 筛选标签 */}
                <div style={{display:'flex', gap:'8px', marginBottom:'12px', overflowX:'auto'}}>
                  {[
                    { key: 'all', label: '全部' },
                    { key: 'recharge', label: '充值' },
                    { key: 'withdraw_apply', label: '提现' },
                    { key: 'transfer_in', label: '转入' },
                    { key: 'transfer_out', label: '转出' },
                    { key: 'payment', label: '消费' },
                  ].map(tab => (
                    <button
                      key={tab.key}
                      onClick={() => setTxFilter(tab.key)}
                      style={{
                        padding: '6px 14px',
                        borderRadius: '20px',
                        border: 'none',
                        fontSize: '13px',
                        cursor: 'pointer',
                        background: txFilter === tab.key ? '#611f69' : '#f0f0f0',
                        color: txFilter === tab.key ? '#fff' : '#666',
                        fontWeight: txFilter === tab.key ? 600 : 400,
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {walletTxs.length === 0 ? (
                  <div style={{textAlign:'center', color:'#999', padding:'20px'}}>暂无交易记录</div>
                ) : (
                  walletTxs
                    .filter((tx: any) => txFilter === 'all' || tx.type === txFilter)
                    .map((tx: any) => (
                      <div key={tx.id} style={{display:'flex', justifyContent:'space-between', padding:'10px 0', borderBottom:'1px solid #f0f0f0'}}>
                        <div style={{flex:1}}>
                          <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                            <span style={{fontSize:'13px', color:'#333'}}>
                              {tx.remark || 
                                (tx.type === 'recharge' ? '充值' :
                                tx.type === 'withdraw_apply' ? '提现' :
                                tx.type === 'withdraw_complete' ? '提现' :
                                tx.type === 'withdraw_reject' ? '提现' :
                                tx.type === 'transfer_in' ? '转账转入' :
                                tx.type === 'transfer_out' ? '转账转出' :
                                tx.type === 'payment' ? '消费' :
                                tx.type === 'bind' ? '钱包激活' :
                                tx.type)}
                            </span>
                            {/* 提现状态标签 */}
                            {tx.type === 'withdraw_apply' && (
                              <span style={{
                                fontSize:'11px', padding:'2px 8px', borderRadius:'10px',
                                background:'#fff3e0', color:'#e65100', fontWeight:600
                              }}>待审核</span>
                            )}
                            {tx.type === 'withdraw_complete' && (
                              <span style={{
                                fontSize:'11px', padding:'2px 8px', borderRadius:'10px',
                                background:'#e8f5e9', color:'#2e7d32', fontWeight:600
                              }}>✅ 已通过</span>
                            )}
                            {tx.type === 'withdraw_reject' && (
                              <span style={{
                                fontSize:'11px', padding:'2px 8px', borderRadius:'10px',
                                background:'#ffebee', color:'#c62828', fontWeight:600
                              }}>❌ 已拒绝</span>
                            )}
                          </div>
                          <div style={{fontSize:'11px', color:'#999', marginTop:'2px'}}>{new Date(tx.created_at).toLocaleString()}</div>
                        </div>
                        <div style={{fontSize:'14px', fontWeight:600, color: tx.amount > 0 ? '#4caf50' : '#f44336', marginLeft:'12px', whiteSpace:'nowrap'}}>
                          {tx.amount > 0 ? '+' : ''}{tx.amount} {tx.currency}
                        </div>
                      </div>
                    ))
                )}
              </div>
            </div>
          )}
        </div>
      );
    }
     
  if (subPage === 'wallet') return renderPlaceholder('💰', t('mine.wallet'), t('mine.walletDesc'));
  if (subPage === 'settings') return renderPlaceholder('⚙️', t('mine.settings'), t('mine.comingSoon'));
  if (subPage === 'service') return renderPlaceholder('💬', t('mine.service'), t('mine.comingSoon'));

  const handleMenuClick = (page: string) => {
    if (!user) return;
    
    if (page === 'claim-coupons') {
      fetchAvailableCoupons();
      fetchUserCoupons();  // ← 加这行：确保已领取数据最新
    }
    if (page === 'my-coupons') {
      fetchUserCoupons();
    }
    
    setSubPage(page);
  };
  
  const fetchUserCoupons = async () => {
    try {
      const res = await axiosClient.get('/api/user/coupons');
      const raw = res?.data;
      let list: any[] = [];
      if (raw && Array.isArray(raw.coupons)) list = raw.coupons;
      else if (Array.isArray(raw)) list = raw;
      
      const safeList = list.map((item: any) => ({
        id: item.id || 0,
        code: item.code || '',
        discount: item.discount || 0,
        type: item.type || 'fixed',
        min_order: item.min_order || 0,
        valid_to: item.valid_to || null,
        max_uses: item.max_uses || null,
        used: item.used || 0,
        merchant_name: item.merchant_name || '',
        status: item.status || 'unused',
        claim_count: item.claim_count || item.used || 0,
      }));
      
      setUserCoupons(safeList);
    } catch (e: any) {
      console.error('fetchUserCoupons error', e);  // ← 改成 console，不再弹窗
      setUserCoupons([]);
    }
  };

  const fetchAvailableCoupons = async () => {
    try {
      const res = await axiosClient.get('/coupons');
      const list = res.data?.coupons || [];
      setAvailableCoupons(Array.isArray(list) ? list : []);
    } catch (e: any) {
      console.error('fetchAvailableCoupons error', e);  // ← 改成 console
      setAvailableCoupons([]);
    }
  };

  const claimCouponById = async (couponId: number) => {
    try {
      await axiosClient.post('/coupons/claim', { coupon_id: couponId });
      alert(t('coupon.claimed') || '领取成功！');
      fetchAvailableCoupons(); // 刷新列表，已领的会变灰或消失
    } catch (e: any) {
      const msg = e.response?.data?.error || '';
      if (msg.includes('Already') || msg.includes('claimed')) {
        alert(t('coupon.alreadyClaimed') || '您已领取过该券');
      } else if (msg.includes('expired') || msg.includes('not found')) {
        alert(t('coupon.invalid') || '优惠券无效或已过期');
      } else {
        alert('领取失败: ' + msg);
      }
    }
  };

  const filteredCoupons = (Array.isArray(userCoupons) ? userCoupons : []).filter((c: any) => {
    if (couponTab === 'all') return true;
    return (c.status || 'unused') === couponTab;
  });

    // 下载 CSV 模板
  
  // 解析上传的 CSV
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result as string;
      const lines = text.split('\n').map(line => line.trim()).filter(line => line);
      if (lines.length < 2) {
        alert(t('mp.csvEmpty') || 'CSV文件为空或格式错误');
        return;
      }
      
      const headers = lines[0].split(',').map(h => h.trim());
      const data: any[] = [];
      
      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',').map(v => v.trim());
        if (values.length < 2 || !values[0]) continue;
        
        const row: any = {};
        headers.forEach((h, idx) => row[h] = values[idx] || '');
        
        // 兼容：如果没有 price 字段，使用 piPrice
        const price = parseFloat(row.price) || parseFloat(row.piPrice) || 0;
        
        data.push({
          name: row.name || '',
          image: row.image || '',
          category: row.category || '',
          price: price,
          piPrice: parseFloat(row.piPrice) || 0,
          originalPrice: parseFloat(row.originalPrice) || 0,
          stock: parseInt(row.stock) || 0,
          description: row.description || ''
        });
      }
      
      setImportData(data);
      alert(`${t('mp.parseSuccess') || '解析成功'}: ${data.length} ${t('mp.items') || '条'}`);
    };
    reader.readAsText(file);
  };

  // 提交批量导入
  const submitBatchImport = async () => {
    if (importData.length === 0) return;
    setImportLoading(true);
    
    try {
      const batchSize = 20;
      let successCount = 0;
      
      for (let i = 0; i < importData.length; i += batchSize) {
        const batch = importData.slice(i, i + batchSize);
        const res = await axiosClient.post('/products/batch', { products: batch });
        if (res.data?.success) {
          successCount += res.data.count || batch.length;
        }
      }
      
      alert(`${t('mp.importSuccess') || '导入完成'}: ${successCount} ${t('mp.items') || '条'}`);
      setShowImportModal(false);
      setImportData([]);
      // 刷新商品列表
      fetchCategories();
      if (subPage === 'merchant') {
        axiosClient.get(`/merchants/products?merchant_id=${selectedMerchantId}`).then((res: any) => {
          setMyProducts(res.data.products || []);
        }).catch(() => {});
      }
    } catch (e: any) {
      alert(`${t('mp.importFail') || '导入失败'}: ${e.response?.data?.error || e.message}`);
    } finally {
      setImportLoading(false);
    }
  };

  // 下单前检查钱包状态
  const checkWalletBeforePay = async () => {
    try {
      const res = await axiosClient.get('/wallet/status');
      if (!res.data?.bound) {
        alert('⚠️ 请先合并账户并激活钱包，才能使用余额支付');
        setSubPage('wallet');
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  };

      // ===== 批量导入全屏页面（Pi Browser 兼容）=====
  if (showImportModal) {
    return (
      <div style={{width:'100%', minHeight:'100vh', background:'#fff', padding:'16px', boxSizing:'border-box'}}>
        <div style={{display:'flex', alignItems:'center', marginBottom:'20px'}}>
          <button 
            style={{background:'none', border:'none', fontSize:'18px', cursor:'pointer'}}
            onClick={() => { 
              setShowImportModal(false); 
              setImportData([]); 
              setShowTemplateText(false);  // ← 加上这行
            }}
          >
            ← 返回
          </button>
          <h3 style={{margin:'0 auto', color:'#611f69', fontSize:'18px'}}>
            {t('mp.batchImport') || '批量导入商品'}
          </h3>
          <div style={{width:'40px'}}></div>
        </div>

        {/* 下载模板区域 */}
        <div style={{marginBottom:'16px', padding:'12px', background:'#f8f9fa', borderRadius:'8px', fontSize:'13px', color:'#666'}}>
          <div style={{fontWeight:600, marginBottom:'8px'}}>
            CSV格式要求：
          </div>
          <code style={{background:'#fff', padding:'4px 8px', borderRadius:'4px', display:'block', marginBottom:'8px', fontSize:'11px', wordBreak:'break-all'}}>
            name,price,piPrice,originalPrice,stock,category,description,image
          </code>
          
          {!showTemplateText ? (
            <button 
              style={{
                padding:'8px 16px', 
                background:'#611f69', 
                color:'#fff', 
                border:'none', 
                borderRadius:'6px', 
                cursor:'pointer', 
                fontSize:'13px',
                width:'100%'
              }}
              onClick={() => setShowTemplateText(true)}
            >
              📄 显示模板内容
            </button>
          ) : (
            <div style={{marginTop:'8px'}}>
              <div style={{fontSize:'12px', color:'#666', marginBottom:'6px'}}>
                👆 长按文本框 → 全选 → 复制 → 粘贴到<b>记事本</b>保存为 .csv
              </div>
              <textarea 
                readOnly
                value={templateContent}
                style={{
                  width:'100%', 
                  height:'120px', 
                  fontSize:'11px', 
                  fontFamily:'monospace',
                  border:'1px solid #ddd',
                  borderRadius:'6px',
                  padding:'8px',
                  background:'#fafafa'
                }}
                onClick={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.select();
                }}
              />
              <div style={{
                marginTop:'8px',
                padding:'10px',
                background:'#fff3e0',
                borderRadius:'6px',
                fontSize:'12px',
                color:'#e65100',
                lineHeight:'1.6'
              }}>
                <b>📋 正确保存方法（二选一）：</b><br/><br/>
                
                <b>方法A（推荐）：</b><br/>
                1. 长按上方文本框 → 全选 → 复制<br/>
                2. 打开<b>手机记事本</b> → 粘贴 → 保存<br/>
                3. 文件名输入：<b>product_template.csv</b><br/>
                4. 用 <b>WPS/Excel 打开</b> 此文件即可编辑<br/><br/>
                
                <b>方法B：</b><br/>
                1. 直接粘贴到 Excel 某单元格<br/>
                2. 选中该单元格 → 点击<b>"数据"→"分列"</b><br/>
                3. 选择<b>"分隔符号"</b> → 勾选<b>"逗号"</b> → 完成
              </div>
            </div>
          )}
        </div>

        <input 
          type="file" 
          accept=".csv" 
          onChange={handleFileUpload}
          style={{marginBottom:'16px', padding:'8px', border:'1px solid #ddd', borderRadius:'8px', width:'100%'}}
        />

        {importData.length > 0 && (
          <div style={{marginBottom:'16px'}}>
            <div style={{fontWeight:600, marginBottom:'8px'}}>
              {t('mp.preview') || '数据预览'}（{t('mp.showFirst5') || '前5条'}）：
            </div>
            <div style={{maxHeight:'200px', overflowY:'auto', border:'1px solid #eee', borderRadius:'8px'}}>
              <table style={{width:'100%', fontSize:'12px', borderCollapse:'collapse'}}>
                <thead>
                  <tr style={{background:'#f8f9fa'}}>
                    <th style={{padding:'8px', textAlign:'left'}}>{t('mp.name') || '名称'}</th>
                    <th style={{padding:'8px', textAlign:'left'}}>{t('label.category') || '分类'}</th>
                    <th style={{padding:'8px', textAlign:'left'}}>Pi {t('label.price') || '价格'}</th>
                    <th style={{padding:'8px', textAlign:'left'}}>{t('mp.stock') || '库存'}</th>
                  </tr>
                </thead>
                <tbody>
                  {importData.slice(0,5).map((row,idx) => (
                    <tr key={idx} style={{borderTop:'1px solid #f0f0f0'}}>
                      <td style={{padding:'8px'}}>{row.name}</td>
                      <td style={{padding:'8px'}}>{row.category}</td>
                      <td style={{padding:'8px'}}>π{row.piPrice}</td>
                      <td style={{padding:'8px'}}>{row.stock}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{marginTop:'8px', color:'#666', fontSize:'13px'}}>
              {t('mp.totalItems') || '共'} {importData.length} {t('mp.items') || '条数据'}
            </div>
          </div>
        )}

        <div style={{display:'flex', gap:'8px', justifyContent:'flex-end'}}>
          <button 
            style={{padding:'10px 20px', background:'#f5f5f5', border:'none', borderRadius:'8px', cursor:'pointer'}}
            onClick={() => { setShowImportModal(false); setImportData([]); }}
          >
            {t('btn.cancel') || '取消'}
          </button>
          <button 
            style={{
              padding:'10px 20px', 
              background:'#611f69', 
              color:'#fff', 
              border:'none', 
              borderRadius:'8px', 
              cursor: importData.length===0 || importLoading ? 'not-allowed' : 'pointer', 
              opacity: importData.length===0 || importLoading ? 0.6 : 1
            }}
            onClick={submitBatchImport}
            disabled={importData.length===0 || importLoading}
          >
            {importLoading ? (t('mp.importing') || '导入中...') : (t('btn.create') || '确认导入')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{paddingBottom:'70px'}}>
      <div className="mine-header">
        <div className="mine-avatar">👤</div>
        <div className="mine-name">{user ? user.username : t('mine.user')}</div>
        <div className="mine-uid" onClick={user ? onSignOut : signIn} style={{ cursor: 'pointer', color: '#6C5CE7' }}>
          {user ? t('mine.signOut') : t('mine.signIn')}
        </div>
      </div>

      <div className="mine-orders">
        <div className="mine-order-item" onClick={() => user && fetchOrders().then(() => setSubPage('orders'))} style={{cursor: user ? 'pointer' : 'default'}}>
          <div className="mine-order-icon">💰</div>
          <div className="mine-order-label">{t('mine.pending')}</div>
        </div>
        <div className="mine-order-item" onClick={() => user && fetchOrders().then(() => setSubPage('orders'))} style={{cursor: user ? 'pointer' : 'default'}}>
          <div className="mine-order-icon">📦</div>
          <div className="mine-order-label">{t('mine.shipping')}</div>
        </div>
        <div className="mine-order-item" onClick={() => user && fetchOrders().then(() => setSubPage('history'))} style={{cursor: user ? 'pointer' : 'default'}}>
          <div className="mine-order-icon">✅</div>
          <div className="mine-order-label">{t('mine.completed')}</div>
        </div>
        <div className="mine-order-item" onClick={() => user && fetchOrders().then(() => setSubPage('orders'))} style={{cursor: user ? 'pointer' : 'default'}}>
          <div className="mine-order-icon">↩️</div>
          <div className="mine-order-label">{t('mine.returns')}</div>
        </div>
      </div>

      <div className="mine-menu">
        {menuItems.map(item => (
          <div className="mine-menu-item" key={item.page} onClick={() => handleMenuClick(item.page)} style={{cursor: user ? 'pointer' : 'default'}}>
            <span className="mine-menu-icon">{item.icon}</span>
            <span className="mine-menu-text">{item.text}</span>
            {(item.badge ?? 0) > 0 && <span style={{background:'#ff4444', color:'white', fontSize:'10px', minWidth:'16px', height:'16px', borderRadius:'8px', display:'inline-flex', alignItems:'center', justifyContent:'center', marginRight:'8px'}}>{item.badge}</span>}
            <span className="mine-menu-arrow">›</span>
          </div>
        ))}
      </div>  {/* mine-menu 结束 */}

      {/* ========== 页面内容区域 ========== */}
      <div style={{padding: '0 16px'}}>
        
            {/* 商家优惠券页面 */}
      {subPage === 'merchant-coupons' && (
        <div style={{padding: '16px 0'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
            <h3>🎫 {t('merchant.coupons')}</h3>
            <button style={{padding: '10px 20px', background: '#611f69', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer'}} onClick={() => setShowCouponModal(true)}>
              + {t('merchant.createCoupon')}
            </button>
          </div>
          
          {coupons.length === 0 ? (
            <div style={{textAlign: 'center', padding: '40px', color: '#999'}}>{t('text.noData')}</div>
          ) : (
            <table style={{width: '100%', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,.1)', borderCollapse: 'collapse'}}>
              <thead>
                <tr style={{background: '#f8f9fa', borderBottom: '2px solid #eee'}}>
                  <th style={{padding: '12px', textAlign: 'left'}}>{t('label.code')}</th>
                  <th style={{padding: '12px', textAlign: 'left'}}>{t('label.discount')}</th>
                  <th style={{padding: '12px', textAlign: 'left'}}>{t('label.minOrder')}</th>
                  <th style={{padding: '12px', textAlign: 'left'}}>{t('label.used')}</th>
                  <th style={{padding: '12px', textAlign: 'left'}}>{t('label.action')}</th>
                </tr>
              </thead>
              <tbody>
                {coupons.map((c: any) => (
                  <tr key={c.id} style={{borderBottom: '1px solid #f0f0f0'}}>
                    <td style={{padding: '12px'}}>{c.code}</td>
                    <td style={{padding: '12px'}}>{c.type === 'percent' ? `${c.discount}%` : `π${c.discount}`}</td>
                    <td style={{padding: '12px'}}>π{c.min_order || 0}</td>
                    <td style={{padding: '12px'}}>{c.claim_count || 0} / {c.max_uses || '∞'}</td>
                    <td style={{padding: '12px'}}>
                      <button style={{background: '#ffebee', color: '#c62828', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer'}} onClick={() => deleteMerchantCoupon(c.id)}>
                        {t('btn.delete')}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

            {/* 批量导入商品模态框 */}
            
            {/* ========== C端：我的优惠券 ========== */}
      {subPage === 'my-coupons' && (
        <div style={{padding: '16px 0'}}>
          <h3 style={{marginBottom: '16px', color: '#333'}}>
            {t('coupon.myCoupons') || '我的优惠券'}
          </h3>
          
          {/* Tab 切换 */}
          <div style={{display: 'flex', gap: '8px', marginBottom: '16px', borderBottom: '1px solid #eee'}}>
            {[
              {key: 'all', label: t('coupon.all') || '全部'},
              {key: 'unused', label: t('coupon.toUse') || '待使用'},
              {key: 'used', label: t('coupon.used') || '已使用'},
              {key: 'expired', label: t('coupon.expired') || '已过期'}
            ].map(tab => (
              <button
                key={tab.key}
                onClick={() => setCouponTab(tab.key as any)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderBottom: couponTab === tab.key ? '2px solid #611f69' : '2px solid transparent',
                  background: 'transparent',
                  color: couponTab === tab.key ? '#611f69' : '#666',
                  cursor: 'pointer',
                  fontWeight: couponTab === tab.key ? 600 : 400
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {filteredCoupons.length === 0 ? (
            <div style={{textAlign: 'center', padding: '40px', color: '#999'}}>
              {t('coupon.unavailable') || '暂无优惠券'}
            </div>
          ) : (
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
              {filteredCoupons.map((c: any, idx: number) => (
                <div key={c.id ? String(c.id) : `c-${idx}`} style={{
                  background: c.status === 'used' || c.status === 'expired' ? '#f5f5f5' : '#fff',
                  borderRadius: '12px',
                  padding: '16px',
                  boxShadow: '0 2px 8px rgba(0,0,0,.08)',
                  borderLeft: '4px solid ' + (c.status === 'unused' ? '#611f69' : '#ccc'),
                  opacity: c.status === 'used' || c.status === 'expired' ? 0.7 : 1
                }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <div>
                      <div style={{fontSize: '18px', fontWeight: 700, color: '#611f69'}}>
                        {c.type === 'percent' ? `${c.discount}%` : `π${c.discount}`}
                        <span style={{fontSize: '13px', fontWeight: 400, color: '#666', marginLeft: '4px'}}>
                          {t('coupon.discount') || '优惠'}
                        </span>
                      </div>
                      <div style={{fontSize: '13px', color: '#666', marginTop: '4px'}}>
                        {t('coupon.minOrder') || '最低消费'}: π{c.min_order}
                      </div>
                      <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                        {t('coupon.validUntil') || '有效期'}: {c.valid_to ? new Date(c.valid_to).toLocaleDateString() : '-'}
                      </div>
                      {c.merchant_name ? (
                        <div style={{fontSize: '12px', color: '#999', marginTop: '2px'}}>
                          {c.merchant_name}
                        </div>
                      ) : null}
                    </div>
                    <div style={{
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      background: c.status === 'unused' ? '#f3e5f5' : c.status === 'used' ? '#e8f5e9' : '#ffebee',
                      color: c.status === 'unused' ? '#611f69' : c.status === 'used' ? '#2e7d32' : '#c62828'
                    }}>
                      {c.status === 'unused' ? (t('coupon.toUse') || '待使用') : c.status === 'used' ? (t('coupon.used') || '已使用') : (t('coupon.expired') || '已过期')}
                    </div>
                  </div>
                  
                  {c.status === 'unused' && (
                    <button 
                      style={{
                        marginTop: '12px',
                        width: '100%',
                        padding: '8px',
                        background: '#611f69',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer'
                      }}
                      onClick={() => setSubPage('home')}
                    >
                      {t('coupon.use') || '去使用'}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

            {/* ========== 领券中心 ========== */}
      {subPage === 'claim-coupons' && (
        <div style={{padding: '16px 0'}}>
          <h3 style={{marginBottom: '16px', color: '#333'}}>{t('coupon.claimCenter')}</h3>
          
          {(availableCoupons || []).length === 0 ? (
            <div style={{textAlign: 'center', padding: '40px', color: '#999'}}>
              {t('coupon.noAvailable') || '暂无可领取的优惠券'}
            </div>
          ) : (
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
              {(availableCoupons || []).map((c: any) => {
                // 判断是否已领取：我的优惠券列表里有没有这个 id
                const isClaimed = userCoupons.some((uc: any) => uc.code === c.code);
                
                return (
                  <div key={c.id} style={{
                    background: isClaimed ? '#f5f5f5' : '#fff',
                    borderRadius: '12px',
                    padding: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,.08)',
                    borderLeft: '4px solid ' + (isClaimed ? '#ccc' : '#611f69'),
                    opacity: isClaimed ? 0.7 : 1
                  }}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                      <div>
                        <div style={{fontSize: '18px', fontWeight: 700, color: '#611f69'}}>
                          {c.type === 'percent' ? `${c.discount}%` : `π${c.discount}`}
                          <span style={{fontSize: '13px', fontWeight: 400, color: '#666', marginLeft: '4px'}}>
                            {t('coupon.discount') || '优惠'}
                          </span>
                        </div>
                        <div style={{fontSize: '13px', color: '#666', marginTop: '4px'}}>
                          {t('coupon.minOrder') || '最低消费'}: π{c.min_order || 0}
                        </div>
                        <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                          {t('coupon.validUntil') || '有效期'}: {c.valid_to ? new Date(c.valid_to).toLocaleDateString() : '-'}
                        </div>
                        <div style={{fontSize: '12px', color: '#999', marginTop: '2px'}}>
                          {c.merchant_name || t('coupon.platform') || '平台券'}
                        </div>
                      </div>
                      
                      <button 
                        disabled={isClaimed}
                        style={{
                          padding: '8px 16px',
                          background: isClaimed ? '#ccc' : '#611f69',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: isClaimed ? 'not-allowed' : 'pointer',
                          fontSize: '14px'
                        }}
                        onClick={() => !isClaimed && claimCouponById(c.id)}
                      >
                        {isClaimed 
                          ? (t('coupon.claimed') || '已领取') 
                          : (t('coupon.claim') || '立即领取')
                        }
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}    

        {/* 如果以后加其他页面，继续往下加 */}
        {/* {subPage === 'xxx' && (...)} */}

      </div>  {/* 内容区域结束 */}

            {/* 语言切换 */}

      <div style={{padding:'16px', borderTop:'1px solid #f0f0f0'}}>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
          <span style={{fontSize:'14px', color:'#666'}}>🌐 {t('lang.title')}</span>
          <select 
            value={lang} 
            onChange={(e) => changeLang(e.target.value as Lang)}
            style={{padding:'6px 12px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'14px', background:'#fff'}}
          >
            {(Object.keys(langNames) as Lang[]).map((l) => (
              <option key={l} value={l}>{langNames[l]}</option>
            ))}
          </select>
        </div>
      </div>

      {/* 商家优惠券创建弹窗 */}
      {showCouponModal && (
        <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}} onClick={(e) => { if(e.target === e.currentTarget) setShowCouponModal(false); }}>
          <div style={{background: '#fff', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '500px'}}>
            <h3 style={{marginBottom: '16px', color: '#611f69'}}>{t('merchant.createCoupon')}</h3>
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.code')}</label>
            <input style={{width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px'}} value={couponForm.code} onChange={e => setCouponForm({...couponForm, code: e.target.value})} placeholder="SAVE10" />
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.discount')}</label>
            <input style={{width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px'}} type="number" value={couponForm.discount} onChange={e => setCouponForm({...couponForm, discount: e.target.value})} placeholder="10" />
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.type')}</label>
            <select style={{width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px'}} value={couponForm.type} onChange={e => setCouponForm({...couponForm, type: e.target.value})}>
              <option value="fixed">{t('coupon.fixed')}</option>
              <option value="percent">{t('coupon.percent')}</option>
            </select>
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.minOrder')}</label>
            <input style={{width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px'}} type="number" value={couponForm.min_order} onChange={e => setCouponForm({...couponForm, min_order: e.target.value})} />
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.maxUses')}</label>
            <input style={{width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px'}} type="number" value={couponForm.max_uses} onChange={e => setCouponForm({...couponForm, max_uses: e.target.value})} placeholder={t('text.unlimited')} />
            
            <label style={{display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 500}}>{t('label.validUntil')}</label>
            <input style={{width: '100%', padding: '10px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '8px'}} type="datetime-local" value={couponForm.valid_to} onChange={e => setCouponForm({...couponForm, valid_to: e.target.value})} />
            
            <div style={{display: 'flex', gap: '8px', justifyContent: 'flex-end'}}>
              <button style={{padding: '10px 20px', background: '#f5f5f5', border: 'none', borderRadius: '8px', cursor: 'pointer'}} onClick={() => setShowCouponModal(false)}>
                {t('btn.cancel')}
              </button>
              <button style={{padding: '10px 20px', background: '#611f69', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer'}} onClick={createMerchantCoupon}>
                {t('btn.create')}
              </button>
            </div>
          </div>
        </div>
      )}

    </div> 
  );
}

